define(['fraud', 'addressForm', 'creditcard', 'orderitems', 'wallet', 'checkout_helper', 'ajaxmodular','accertifyThreeDS','applepay','unifiedapplepay'], function(fraud, addressForm, creditcard, orderitems, wallet, checkout_helper, ajaxmodular,accertifyThreeDS,applepay,unifiedapplepay) {
  let OrderSummary = {
    preventHtmlReload: false,
    isQuickMembershipTncScrolled: false,
    deliveryIndicator: '',
    // init is called from OrderSummary.jsp in order to re-attach event handlers after a successful ajax call replaces the jsp
    init: function(state) {
      $('#apply-membership input').unbind('click').on('click', OrderSummary.applyMembership);
      COSTCO.util.triggerClickOnEnterKeyPress('input[name=add-membership-number]', '#apply-membership input');
      $('#edit-membership-number').unbind('click').on('click', OrderSummary.editMembership);
      $('#enter-promo-link').unbind('click').on('click', OrderSummary.showPromoCodeInputBlock);
      $('input[name=apply-promo]').unbind('click').on('click', OrderSummary.applyPromoCode);
      COSTCO.util.triggerClickOnEnterKeyPress('input[name=enter-promo-code]', 'input[name=apply-promo]');
      $('.remove-promo').unbind('click').on('click', OrderSummary.removePromoCode);
      OrderSummary.creditInputMsg();
      
      $("#shop-card-block").unbind('click').click(function (event) {
  		event.preventDefault();  		
  		COSTCO.DigitalWallet.toggleUseDigitalWallet($(this));
      });

      if(state == 'quick-membership' || state == 'quick-membership-renew'){
    	  COSTCO.OrderSummary.membershipTncValidator.validateScroll();
      }        
      if (sessionStorage.getItem("membershipReferalId") != null ) {
    	  $('#CheckoutPaymentForm').find('input[name=membershipReferalId]').val(sessionStorage.getItem("membershipReferalId"));
      }
      let initialDelIndicator = '';
      
      initialDelIndicator = $('#deldatepicker').parents('div[class="radio-fieldset-nd-rebranding selection-box-v3 store-Pick-Up"]').children('input').is(':checked');
      if (initialDelIndicator) {
    	  OrderSummary.deliveryIndicator = "Store-Pick-Up";
      } else {
    	  initialDelIndicator = $('#deldatepicker').parents('div[class="radio-fieldset-nd-rebranding selection-box-v3 local-delivery"]').children('input').is(':checked');
    	  if (initialDelIndicator) {
    		  OrderSummary.deliveryIndicator = "Local";
    	  }
      }       
      
      COSTCO.OrderSummary.preventHtmlReload = state === 'quick-membership' || state === 'live-tickets' || costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE;
      
      $('#ponote-block-change').unbind('click').on('click', OrderSummary.editPoNotes);
      $('#terms_checkbox').unbind('click').on('click', OrderSummary.changeColorForLiveTicketTerms);

      if(state == 'quick-membership' || state == 'quick-membership-renew'){
    	  COSTCO.OrderSummary.membershipTncValidator.validateScroll();
      }
      if((state == 'payment' || state == 'review' || state == 'shipping')){
    	if($('#isBDAppVar').val() == 'BD'){  
            OrderSummary.preventSubmitPONotesForm();
            // Workaround for ajax modular (ALM2902). Keep ponote value in tmp global js variable to get it after the page get replaced due to address verification ajax call
            if (globalPoNote != '') {
              orderitems.copyPoNotes(globalPoNote);
            }
          orderitems.bindPoNotes();
          orderitems.bindDeliveryMethod();
          OrderSummary.addValidationToPoNotes();
        }
      }
      if(COSTCO.util.isNdEnabled() && (state == 'payment' || state == 'review' || state == 'shipping' || state == 'confirm')){
          var orderTotal = parseFloat($.cookie('wcCartOrder'));
          OrderSummary.displaySurchargeAmount(orderTotal);
          COSTCO.OrderItems.popovers();
      }
      if((state == 'payment' || state == 'review') && (!creditcard.isPaymentEditAreaVisible() && !COSTCO.Checkout.displayAllPayments())){
          //wallet.init is called by Visa Checkout on .com and wallet.init causes the credit
          //card payment-radio button to be checked. This below code to uncheck the radio button
          //needs to run after wallet is initialized
          if (typeof window.COSTCO.wallet === 'undefined') {
            document.addEventListener('WalletInitialized', OrderSummary.uncheckPaymentRadio, false);

          } else {
            $('input[name=payment-radio]').each(function(){
              OrderSummary.uncheckPaymentRadio();
            });
          }
        }

        if (state === 'review') {
          if($('#isBDAppVar').val() === 'BD'){
            OrderSummary.bindResaleOption(state);
            orderitems.delDatePicker();
          } else {
            if(!$('.order-error').is(':visible')){
              $('#contractErrContainer').removeClass('hidden');
            }
          }
          $('input[name=place-order]').unbind('click').on('click', orderitems.validate.bind(null, OrderSummary.submitOrder, ''));
          $(document).ready(function(e) {
            if($('#critical-notification-store-error').text() != '') {
                creditcard.validate.creditCardForm();
             }
          });

        } else if (state === 'shipping') {
          if ($('#isBDAppVar').val() === 'BD') {
            OrderSummary.bindResaleOption(state);
            orderitems.delDatePicker();
          } else {
            if (!$('.order-error').is(':visible')) {
              $('#contractErrContainer').removeClass('hidden');
            }
          }
          $('input[name=place-order]').unbind('click').on('click', orderitems.validate.bind(null, OrderSummary.submitShipping, ''));
          $('input[name=place-order-multi]').unbind('click').on('click', orderitems.validate.bind(null, OrderSummary.submitMultiShipping, ''));

        } else if (state === 'payment' || state === 'quick-membership' || state === 'quick-membership-renew' || state === 'live-tickets') {
          if (wallet.walletModuleEnabled === 'true') {
            if (state === 'quick-membership-renew') {
            	if (costcoStoreFeatures.MEMBERSHIP_RECAPTCHA_ENABLED === true && $('#membershipRecaptcha').length > 0) {
	           		 $('input[name=place-order]').unbind('click').on('click', OrderSummary.executeMembershipRecaptcha);
	           	 } else {
	           		$('input[name=place-order]').unbind('click').on('click', {isWalletPayment : true}, OrderSummary.submitQuickMembershipForRenew);
	           	 }
            } else {
            	 if (costcoStoreFeatures.MEMBERSHIP_RECAPTCHA_ENABLED === true && state === 'quick-membership' && $('#membershipRecaptcha').length > 0) {
            		 $('input[name=place-order]').unbind('click').on('click', OrderSummary.executeMembershipRecaptcha);
            	 } else {
            		 $('input[name=place-order]').unbind('click').on('click', OrderSummary.submitForReviewWithWallet);
            	 }
            }

            $('input[name=payment-radio]').unbind('click').on('click', function() {
              creditcard.hideErrorBox();
              wallet.hideErrorBox();
              wallet.hideErrorMessage();
            });
          } else if($('#isBDAppVar').val() === 'BD') {
            // On payment page init, if default method ACH and submitPayMethod exists - override defaultpaymethodid value for this order
            var paymentType=$('input[name=payMethodId]').val();
            var submitedPaymentType=$('#submitedPayMethodId').val();
            if (submitedPaymentType.length>0) {
              paymentType= ( paymentType != submitedPaymentType ? submitedPaymentType : paymentType);
              $('input[name=payMethodId]').val(paymentType);
            }   
            // On payment page init, if default method ACH then 1. Check ACH radio button 2. Check Agree to ach terms and conditions checkbox
            if (($('input[name=payMethodId]').val() === 'ACH') && !(creditcard.isPaymentEditAreaVisible())) {      
              $('#radio-ach').prop('checked', true);
              $('#save_as_default2').prop('checked', true);
            };
          
            // On payment page init, if edit area visible
            if ((state === 'payment') && (creditcard.isPaymentEditAreaVisible())) {
              //If backend error is visible, check submitedPaymentMethod to display related form
              if ($('#critical-notification-store-error').text() != '') {
                if (paymentType === 'Check') {
                  COSTCO.wallet.showCheckOnDeliverySection();
                } else if(paymentType === 'ACH') {
                  COSTCO.wallet.showACHSection();
                } else if(paymentType === 'LineOfCredit') {
                  COSTCO.wallet.showAcctReceivableSection();
                } else {
                  COSTCO.wallet.showCCSection();
                }
              }
            }
          
            $('input[name=place-order]').unbind('click').on('click', OrderSummary.submitForReviewWithWallet);
            $('input[name=payment-radio]').unbind('click').on('click', function() {
              creditcard.hideErrorBox();
              wallet.hideErrorBox();
              wallet.hideErrorMessage();
            });

          } else {
            if (state === 'quick-membership-renew') {
            	if (costcoStoreFeatures.MEMBERSHIP_RECAPTCHA_ENABLED === true && $('#membershipRecaptcha').length > 0) {
	           		 $('input[name=place-order]').unbind('click').on('click', OrderSummary.executeMembershipRecaptcha);
	           	 } else {
	           		$('input[name=place-order]').unbind('click').on('click', {isWalletPayment : false}, OrderSummary.submitQuickMembershipForRenew);
	           	 }
            } else {
            	 if (costcoStoreFeatures.MEMBERSHIP_RECAPTCHA_ENABLED === true && state === 'quick-membership' && $('#membershipRecaptcha').length > 0) {
            		 $('input[name=place-order]').unbind('click').on('click', OrderSummary.executeMembershipRecaptcha);
            	 } else {
            		 $('input[name=place-order]').unbind('click').on('click', OrderSummary.submitForReview);
            	 }
            }
         
          }
        }


      if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE === true) {
        if (state === 'review') {
          COSTCO.util.makeElementSticky("order-summary-column", "checkout-header", "footer-section");
          if($('#isBDAppVar').val() === 'BD') {
            let orderTotal = parseFloat($.cookie('wcCartOrder'));
                if (COSTCO.util.isNdEnabled()) {
                	COSTCO.OrderSummary.displaySurchargeAmount(orderTotal);
                	COSTCO.OrderSummary.updateShipmodeDetails();
                }
            OrderSummary.preventSubmitPONotesForm();
            if (globalPoNote != '') {
              orderitems.copyPoNotes(globalPoNote);
            }
            orderitems.bindPoNotes();
            OrderSummary.addValidationToPoNotes();
          }
        }
      } else {
        // makeElementSticky() function call
    	$(window).on('load',function() {
          OrderSummary.affix();
        });
      }
      
      
      //Check for invalid ship mode for all the products in cart and display error message.
      //STRY0182081 changes starts
      if(checkoutPage == 'review' && $('#isBDAppVar').val() == 'BC') {
    	COSTCO.OrderItems.validateShipMode(true);
      }
      //STRY0182081 changes ends
      
      $(window).on('beforeunload', function(){
    	  if(checkoutPage == 'review' && $('#isBDAppVar').val() == 'BC') {
    		  COSTCO.OrderItems.saveMeasurementGuidesCheckboxesStates();
          }
    	});
      
      $(document).ready(function() {
    	  if(checkoutPage == 'review' && $('#isBDAppVar').val() == 'BC') {
    		   let doesMeasurementGuidesChexboxExsts = ($('input[id^="measuring-guides-checkbox-"]').length > 0) ? true : false;  
		   	   if (doesMeasurementGuidesChexboxExsts) {
		   		COSTCO.OrderItems.populateMeasurementGuidesCheckboxes();	
		   		var hasQCInsuranceTaxACItems = document.getElementById('hasQCInsuranceTaxACItems');
		   		

		   		   
		   		$('input[id^="measuring-guides-checkbox-"]').on('click', function() {
		    		   if (COSTCO.OrderSummaryCart.firstMeasurementGuideValidation) {
			    		   if (!$(this).is(":checked")) {
			    			   COSTCO.OrderItems.highlightMeasuringError(this);
			    		   } else {
			    			   COSTCO.OrderItems.unhighlightMeasuringError(this);
			    		   }
		    		   }   
		    	   });
		   	   }
    	  }
      });
      const additionalBillingStatesCode = addressForm.getAdditionalBillingStates();
      $('#S_stateId').on('change', function() {
			if(additionalBillingStatesCode !== null && additionalBillingStatesCode !== undefined) {
				if (additionalBillingStatesCode.length !== 0) {
					if ($.inArray(this.value, additionalBillingStatesCode) !== -1) {
						$('#save-to-address-book').prop('checked', false);
						$('#save-to-address-book').addClass('hide');
						$("#set-default-address").addClass('hide');
					} else {
						$('#save-to-address-book').prop('checked', true);
						$('#save-to-address-book').removeClass('hide');
						$('#set-default-address').removeClass('hide');
					}
				}
			}
	})
      
    },

    checkoutSteps: {

      /**
       * Constants that represents checkout step numeric identifiers
       */
      SHIPPING_ADDRESS: 1,
      PAYMENT: 2,
      SHIPPING_OPTIONS: 3,

      /**
       * Submits checkout step to proceed to the next step in checkout wizard (flow)
       *  1: Shipping address step
       *  2: Payment step
       *  3: Shipping options step
       */
      submitCheckoutStep: function(stepNumber, multiAddress) {
    	  
  	    if($('#isStorePickupSelected').val() === 'true' ){
  		  if($('#companyNameId').val().trim().length < 1) {
  			  let errorElement = document.getElementById("company_name_validator_err_msg");
  			  $(errorElement).removeClass("hide");
  			  $('#companyNameId').addClass("error");
  			  return ;
  		  } else {
  			  let companyName = $('#companyNameId').val();
  			  $('#companyNamePaymentForm').val(companyName);

  		  }
  		}
    	  
        if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_AJAX_FLOW_FEATURE_ENABLE === true) {
           OrderSummary.checkoutSteps.overrideDefaultShippingAddressFormSubmit();
        }
        if (COSTCO.OrderSummary.needsToUpdatePoNotes() === 'true') {
            COSTCO.OrderSummary.updateCustomerPoNotes();
        }
        if(OrderSummary.checkoutSteps.canProceedToNextStep()) {
          if(stepNumber == OrderSummary.checkoutSteps.SHIPPING_ADDRESS){
        	  OrderSummary.checkoutSteps.submitShippingAddressStep();
          } else if(stepNumber == OrderSummary.checkoutSteps.PAYMENT){
        	  OrderSummary.checkoutSteps.submitPaymentStep();
          } else if(stepNumber == OrderSummary.checkoutSteps.SHIPPING_OPTIONS){
        	  	if(COSTCO.Checkout.displayAllPayments() && COSTCO.CreditCard.isSelected() && COSTCO.Checkout.usedPayment()==="wallet"){
		    		COSTCO.Checkout.deletePaymentInstructionsForOrder().then(function(){
         	  			$('.payment-method-change').addClass('hide');
          	  			$('input[id=appliedPayMethod]').val('');
	          	  		$('input[id=isApplePaySheetSubmitted]').val('');
	    				$('input[id=unifiedPaymentType]').val('');
          	  			$('input[name=piId]').val('');
          	  			$('input[id=usedPayMethod]').val('');
          	  			$('input[name=doBillingPaymentCmd]').val('true');
          	  			$('input[name=walletCheckout]').val('false');
          	  			OrderSummary.checkoutSteps.submitShippingOptionsStep();
          	  		COSTCO.Checkout.removeClickToPayTriggered();
          	  		});
				} else {
					OrderSummary.checkoutSteps.submitShippingOptionsStep();
	      	  		COSTCO.Checkout.removeClickToPayTriggered();
				}
          } else {
        	  console.error('Unsupported step number ' + stepNumber + ' as checkout wizard operation. Supported steps are: 1, 2, 3.');
          }
        }
      },

      /**
       * Submits shipping address step in checkout wizard
       */
      submitShippingAddressStep: function() {
          OrderSummary.submitShipping();
      },

      /**
       * Submits payment step in checkout wizard 
       */    
      submitPaymentStep: function() {
        if (COSTCO.timeoutModal.state === COSTCO.timeoutModal.TIMEDOUT) {
        	document.location.href = 'ReLogonFormView?URL=SinglePageCheckoutView';
         } 
        OrderSummary.submitForReviewWithWallet(true);
      },

      /**
       * Submits shipping options step in checkout wizard
       */    
      submitShippingOptionsStep: function() {
        orderitems.validate(OrderSummary.submitOrder, '');
      },

      /**
       * This function is used to conduct all the necessary validations that are needed
       * in order to proceed to the next step
       */
      canProceedToNextStep:  function() {
        let isValidCurrentStep = true;
        //check if alcohol terms are checked for alcohol items
        if ($('#alcoholTermsDiv').length > 0) {
          isValidCurrentStep = isValidCurrentStep && OrderSummary.ageRestrictionTermsValidator.isValid('ALCOHOL_RESTRICTION');
        }

        if ($('#tobaccoTermsDiv').length > 0) {
          isValidCurrentStep = isValidCurrentStep && OrderSummary.ageRestrictionTermsValidator.isValid('TOBACCO_RESTRICTION');
        }

        if ($('#edit-tires-contact-information-phone input[id^=smsPhoneId_]').length > 0
        		&& $('#tires-contact-information-phone').hasClass('hide')) {
        	let form = $('[id^=edit-tires-contact-information-phone] input[id^=tiresSmsPhoneId_]').closest("form").attr('id');
        	isValidCurrentStep = isValidCurrentStep && OrderSummary.smsValidator.isValid($("#"+form), "[id^=edit-tires-contact-information-phone] input[id^=tiresSmsPhoneId_]");
        }
        
        if($("#ShopCartForm .smsPhoneInput").length > 0 ) {
	    	$("#ShopCartForm .smsPhoneInput").each(function() {
	    		let form = $(this).closest("form").attr('id');
	    		let isValidEachInput = OrderSummary.smsValidator.isValid($("#"+form), '#'+this.id);
	    		if(isValidEachInput == false) {
	    			isValidCurrentStep = false;
	    		} 
	    	});
    	} else {
    		if($('[id^=mobile-phone-input_] .smsPhoneInput').length > 0 && $('[id^=mobile-phone-input_] .smsPhoneInput').text().length > 0) {
    			isValidCurrentStep = OrderSummary.smsValidator.isValid($("[id^=mobile-phone-input_]"), 'input[id^=smsPhoneId_]');
    		}
    	}
        
        if ($('#edit-contact-information-text').length > 0 && !$('#edit-contact-information-text').hasClass('hide')) {
        	isValidCurrentStep = isValidCurrentStep && COSTCO.CAddressForm.validateContactInformation();
        }
        
    	if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_CUSTOMER_PO_NOTES_FEATURE_ENABLED === true) {
			isValidCurrentStep = isValidCurrentStep && OrderSummary.validatePoNotes();
        }
    	let isNDSelected = $('#deldatepicker').parents('label[name="delivery-options-radio"]').children('input').is(':checked');
        if (COSTCO.util.isNdEnabled() && $('#shipmodeDescription').val() != messages.ACTION_ORDER_PICKUP) {
        	isNDSelected = $('#deldatepicker').parents('div[class="radio-fieldset-nd-rebranding selection-box-v3 local-delivery"]').children('input').is(':checked')
        }
    	
    	if($('#isBDAppVar').val() == 'BD' && costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE){
    	    if ($('#order-level-delivery-options').length > 0 && $('#deldatepicker').length > 0 && isNDSelected) {
    			isValidCurrentStep = isValidCurrentStep && COSTCO.OrderSummary.validateDate()
    		} 
    	}
    	
    	if ($('.promo-adjustment').length > 0) {
    		isValidCurrentStep = isValidCurrentStep && OrderSummary.validatePromoAdjustments();
    	}
    	if ($('#isBDAppVar').val() == 'BC') {
    		isValidCurrentStep = COSTCO.OrderItems.validateMeasurementGuidesEligibility();
    		COSTCO.OrderSummaryCart.firstMeasurementGuideValidation = true;
    	}
        //STRY0182081 changes start: This will check for the valid shipping method linked to the items.
    	if ($('#isBDAppVar').val() == 'BC' && $('.primary-button-green-v2').val() == 'Place Order') {
				
			  var hasValidShipmodeId = COSTCO.OrderItems.validateShipMode();
//    		  var hasValidShipmodeId = true;
			  /* Check ifthe isValidCurrentStep flag is false. If not then check if the hasValidShipmodeId is false, 
			   * then set the invalid shipping error message.
			   */
			  if (isValidCurrentStep && !hasValidShipmodeId) {
				  //There is invalid shipping mode error. So set the error message.
				  //Show the error message at the page level, stating there is an invalid shipment assigned to a product.
				  var errLoc = "#errquantity_";
				  $(errLoc).addClass('critical-notification');
		          $(errLoc).html('<p class="sr-only">' + messages.ERROR + '</p>').show();
		          $(errLoc).html('<p>' + messages.ERR_INVALID_SHIPPING_METHOD_CART + '</p>').show();
			  }
	      	  isValidCurrentStep = isValidCurrentStep && hasValidShipmodeId;
	      	  
    	}
    	//STRY0182081 changes end: This will check for the valid shipping method linked to the items.
    	
        return isValidCurrentStep;
      },

      /**
       * Overriding deafult shipping address form submit, so that we can wrap it with ajax modular
       * for single page checkout
       */
      overrideDefaultShippingAddressFormSubmit: function() {
        let formName = '#NewAddressSingleShippingForm';
        let ajaxUrl = '/AjaxSubmitShippingAddressCheckoutStep';
        OrderSummary.checkoutSteps.overrideDefaultFormSubmitWithAjaxModular(formName, ajaxUrl, function() {
          TokenGateway.refreshGateway();
        });
      },

      /**
       * Generic function to wrap a form submit with ajax modular call
       */
      overrideDefaultFormSubmitWithAjaxModular: function(formName, ajaxUrl, post_done_callback) {
        if (formName.length > 0) {
          $(formName).unbind('submit').submit(function(event) {
            event.preventDefault();
            event.stopPropagation();

            let formData = $(formName).serialize();
            ajaxmodular.ajax_update_state({
              method: 'POST',
              url: ajaxUrl,
              data: formData,
              dataType: 'json',
              ajax_update_post_done: post_done_callback,
            }); 

          });

          console.log('sumbit function overriden for form: ' + formName);
        } else {
          console.log('sumbit function WAS NOT overriden for form:' + formName);
        }

      }

    },
    
    /**
     * Prevents PO notes form submission on enter key press
     * 
     */
    preventSubmitPONotesForm: function() {
	    $("#po-notes-facade-form").on("submit", function(e){
	    	e.preventDefault();
	    	// prevent .j console error from onsubmit listener
	    	e.stopPropagation();
  		});
    },
    /**
     * Binds action for resale option.
     */
    bindResaleOption: function(state){
    	 $('.resale-edit').unbind('click').on('click', function(){
    		$(".resale_text").removeClass('hide');
    		$(".resale_radio").addClass('hide');
    		$(this).closest(".delivery-option-radios").find(".resale_text").addClass('hide');
    		$(this).closest(".delivery-option-radios").find(".resale_radio").removeClass('hide');
   	  });
   	  $('.resale_option').unbind('click').on('click', function(){
   		COSTCO.OrderItems.resaleOptionHandler(this,true);
   	  });
   	  if(state=='shipping'){
   		COSTCO.OrderItems.resaleLicenseModal();
   	  }
    },

    /**
     * Submits Ajax post request to apply promotion code entered into the
     * promo code input box.
     */
    applyPromoCode: function() {
      $('#promo-code-success').html('');
      $('#promo-code-success').addClass('hide');
      if (OrderSummary.validatePromoCode()) {
        let orderPromoUrl = $('input[name=order-promo-url]').val();
        let taskType = 'A';
        let code = $('input[name=enter-promo-code]').val().trim().toUpperCase();
        COSTCO.Checkout.ajax_update_state({
          url: orderPromoUrl,
          method: 'POST',
          dataType: 'json',
          data: {
            'authToken': COSTCO.Checkout.getAuthToken(),
            'promoCode': code,
            'taskType': taskType,
          },
          replaceKey: {
            original: 'order-summary-body',
            replace: 'order-summary-body',
          },
          error_container: '#promo-code-error',
          not_critical_notification: true,
          scrollToError: false,
          done: function(data, textStatus, jqXHR, options) {
        	  if(costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE) {
        	    $('#notification-message .order-error').removeClass('critical-notification');
        	    if(typeof COSTCO.CreditCard !== 'undefined'){
          		  COSTCO.CreditCard.initComplete = false;
        	    }
        	  }
        	  COSTCO.Checkout.ajax_update_default_done(data, textStatus, jqXHR, options);
          },
          ajax_update_post_done: function(response_obj, mergedOptions, defaultOptions) {
        	  
        	  COSTCO.OrderSummary.refreshDeliveryOptionSurcharge();
        	  
        	  let hasErrors = function(response_obj) {
        		  return (response_obj.error.application != undefined && response_obj.error.application.length > 0) 
    			  || (response_obj.error.exception != undefined && response_obj.error.exception.length > 0)
        	  };
        	  
        	  if(!hasErrors(response_obj)) {
        		  $('#promo-code-success').html(messages.RWD_PROMO_CODE_SUCCESS);
        		  $('#promo-code-success').removeClass('hide');
        		  COSTCO.util.announceSRMessage(messages.RWD_PROMO_CODE_SUCCESS);
        		  
        		  if(COSTCO.DigitalWallet.digitalWalletApplied){
					$("#dw-checkout-form input[name=action]").val('add');
		    		COSTCO.DigitalWallet.addDigitalWallet();
        		  }
        	  }
          },
          ajax_handle_errors: function(response_obj, mergedOptions, defaultOptions) {
            COSTCO.Checkout.ajax_handle_errors(response_obj, mergedOptions, defaultOptions);

            $('#enter-promo-code-input').off('focus').on('focus', function() {
              if ($('#promo-code-error').length > 0) {
                let errorMessage = response_obj.error !== undefined ? response_obj.error.application[0] : null;
                let currentValueOnFocus = $(this).attr('aria-describedby');
                if (currentValueOnFocus === undefined || currentValueOnFocus === '') {
                  if (errorMessage !== null && errorMessage !== '') {
                    COSTCO.util.announceSRErrorMessage(errorMessage);
                  }
                };
              }
            });
          },
          always: function(){
        	  if($('#orderHasEddItems').val() == 'true'){
					COSTCO.EDDService.callEddService();
				}
        	  var pickUpAPIResp = $('#pickUpAPIResponses').val()
			  if(pickUpAPIResp != undefined && pickUpAPIResp != null && pickUpAPIResp != '') {
					COSTCO.OrderItems.repaintPickUpMolecule(JSON.parse(pickUpAPIResp), true, true);
			  }
        	  COSTCO.OrderItems.displayGlobalPickUpAlerts(false, true);
          }
        });
      }
    },
    /**
     * Shows the input box and apply button for entering promo code
     */
    showPromoCodeInputBlock: function() {
      $('#promo-code-link-block').addClass('hide');
      $('#promo-code-input-block').removeClass('hide');
      $('input[name=enter-promo-code]').select();
    },
    
    refreshDeliveryOptionSurcharge: function() {
      var deliverySurcharge = $('#bdDelSurcharge').length > 0 ? parseFloat($('#bdDelSurcharge').val()) : 0;
  	  if ($('.delivery-surcharge-nd-off') && $('.delivery-surcharge-nd-off').is(':visible')) {
            if (deliverySurcharge.toFixed(0) === "0") {
              $('.delivery-surcharge-nd-off').hide();
              $('.delivery-surcharge-nd-off-waived').show();
            } else {
              $('.delivery-surcharge-nd-off-waived').hide();
              $('.delivery-surcharge-nd-off').show();
            }
       }
    },
    
    /**
     * validate selection of live tickets agreement 
     */
    validateLiveTicketsOrderAgreement: function() {
    	OrderSummary.changeColorForLiveTicketTerms();
    	if($('#terms_checkbox').is(':checked')){
    		return true;
    	} else {
    		return false;
    	}
    },
    /**
     * check does order agreement is checked and change color order agreement if it is not selected
     */
    changeColorForLiveTicketTerms: function() {
    	if(typeof $('#live-tickets-order-agreement') !== 'undefined' && $('#live-tickets-order-agreement').length > 0){
	    	if($('#terms_checkbox').is(':checked')){
	    		$('#live-tickets-order-agreement').removeClass('warning-unchecked');
	    		$('#live-tickets-order-agreement').addClass('warning');
	    	} else {
	    		$('#live-tickets-order-agreement').removeClass('warning');
	    		$('#live-tickets-order-agreement').addClass('warning-unchecked');
	    	}
    	}
    },
    /**
     * Not being used but maybe in the future?
     * Hides the input box and apply button for entering promo code
     * and shows the Enter Promo Code link instead
     */
    hidePromoCodeInputBlock: function() {
      $('#promo-code-input-block').addClass('hide');
      $('#promo-code-link-block').removeClass('hide');
    },
    /**
     * Submits Ajax post request to remove promotion code from the order.
     * The promotion code being removed is the one that had the remove link
     * clicked on.
     */
    removePromoCode: function() {
      let orderPromoUrl = $('input[name=order-promo-url]').val();
      let taskType = 'R';
      let code = $(this).data('value');
      COSTCO.Checkout.ajax_update_state({
        url: orderPromoUrl,
        method: 'POST',
        dataType: 'json',
        data: {
          'authToken': COSTCO.Checkout.getAuthToken(),
          'promoCode': code,
          'taskType': taskType,
        },
        replaceKey: {
          original: 'order-summary-body',
          replace: 'order-summary-body',
        },
        error_container: '#promo-code-error',
        scrollToError: false,
        done: function(data, textStatus, jqXHR, options) {
      	  if(costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE) {
      	    $('#notification-message .order-error').removeClass('critical-notification');
      	    if(typeof COSTCO.CreditCard !== 'undefined'){
        		  COSTCO.CreditCard.initComplete = false;
      	    }
      	  }
      	  COSTCO.Checkout.ajax_update_default_done(data, textStatus, jqXHR, options);
      	  
      	  COSTCO.OrderSummary.refreshDeliveryOptionSurcharge();
        },
        always: function(){
			if($('#orderHasEddItems').val() == 'true'){
						COSTCO.EDDService.callEddService();
					}
			var pickUpAPIResp = $('#pickUpAPIResponses').val()
			if(pickUpAPIResp != undefined && pickUpAPIResp != null && pickUpAPIResp != '') {
				COSTCO.OrderItems.repaintPickUpMolecule(JSON.parse(pickUpAPIResp), true, true);
			}
			COSTCO.OrderItems.displayGlobalPickUpAlerts(false, true);
        }
      });
    },
    /**
     * Submits Ajax post request to update membership number on order.
     * If user applies the same membership number as they had before,
     * then no request is submitted
     */
    applyMembership: function() {
    	var valid=false;
    	if($('#isBDAppVar').val() == 'BD'){
    		valid=OrderSummary.validateMembershipNumberBD();
    	}
    	else{
    		valid=OrderSummary.validateMembershipNumber();
    	}
      if (valid) {
        let membershipNumber = $('input[name=add-membership-number]').val();
        let oldMembershipNumber = $('#membership-number').text();
          let applyMembershipUrl = $('input[name=apply-membership-url]').val();
          COSTCO.Checkout.ajax_update_state({
            url: applyMembershipUrl,
            method: 'POST',
            dataType: 'json',
            data: {
              'authToken': COSTCO.Checkout.getAuthToken(),
              'membershipNum': membershipNumber,
            },
            replaceKey: {
              original: 'order-summary-body',
              replace: 'order-summary-body',
            },
            error_container: '#membership-number-error',
            input_container: 'input[name=add-membership-number]',
            scrollToError: false,
            not_critical_notification: true,
            done: function(data, textStatus, jqXHR, options) {
             if(costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE && COSTCO.CreditCard !== undefined){
               COSTCO.CreditCard.initComplete = false;
             }
             COSTCO.Checkout.ajax_update_default_done(data, textStatus, jqXHR, options);
             },
             always: function(){
            	 COSTCO.OrderItems.displayGlobalPickUpAlerts(false, true);
             }
          });
      }
    },
    /**
     * Shows the membership number input box and apply button
     * The input box will have the current membership number pre-filled
     */
    editMembership: function() {
      let savedMembership = $('#membership-number').text();
      $('input[name=add-membership-number]').val(savedMembership);
      $('#rewards-block').addClass('hide');
      $('.rewards-block').addClass('hide');
      $('#edit-membership-block').addClass('hide');
      $('#apply-membership-block').removeClass('hide');
      $('input[name=add-membership-number]').select();
    },
    /**
     * Shows the poNotes input field
     * The input field will have the current membership number pre-filled if exists
     */
    editPoNotes: function() {
      $('#po-notes-facade-static-text').addClass('hide');
      $('#po-notes-facade').removeClass('hide');
      $('#po-notes-facade').select();
    },
    placeOrder: function() {
    	if (OrderSummary.validateMembershipRequired()) {
    		
    		$('.order-ajax').addClass('ajax-busy');
    		$('input[name=place-order]').attr('disabled', true);
    		
    		// Pull the estimated delivery dates off the screen
    		// and put them in the request for the final call to consume
    		
    		let deliveryOptionItemIdentifier = '';
    		if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE !== true) {
    			deliveryOptionItemIdentifier = '.delivery-options-selected';
    		} else {
    			deliveryOptionItemIdentifier = 'span.selection-item';
    		}
    			
    		if (typeof $(deliveryOptionItemIdentifier) !== 'undefined') {
    			let estimatedDeliveryDateString = "";

    			$(deliveryOptionItemIdentifier).each(function() {

    				let shipModeId = $(this).attr('data-shipmodeid');
    				let orderItemId = $(this).attr('data-orderitem');

    				let estimatedDeliveryDate = '.edd-non-formatted-date_'+ shipModeId + '_'+ orderItemId;
    				//added data-warehousepickup to edd-container inside this block - check for true and add "_whs"
    				if (typeof $(deliveryOptionItemIdentifier + '[data-orderitem=' + orderItemId + ']').find('.edd-container[data-warehousepickup=true]')[0] !== 'undefined') {
    					estimatedDeliveryDate += '_whs';
    				}

    				if (typeof $(deliveryOptionItemIdentifier + '[data-orderitem=' + orderItemId + ']').find(estimatedDeliveryDate)[0] !== 'undefined' ) {
    					estimatedDeliveryDateString += orderItemId + ':' + $(deliveryOptionItemIdentifier + '[data-orderitem=' + orderItemId + ']').find(estimatedDeliveryDate)[0].value + ',';
    				}
    			})	
    			if ($('#estimatedDeliveryDateList')) {
    				$('#estimatedDeliveryDateList').val(estimatedDeliveryDateString);
    			}
    		}
    		
    		
    		
    		var isValid = true;
            let shipModeDescription = ($('#shipmodeDescription').val()) ? $('#shipmodeDescription').val().toUpperCase(): "";
        	if($('#isBDAppVar').val() == 'BD'){
        		isValid = OrderSummary.validateMembershipRequired();
        		if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE !== true) {
        			isValid = isValid && OrderSummary.validatePoNotes();
        		}
        		if($('#ach_account_type').val()==null || $('#ach_account_type').val() == ''){
        			$('#ach_account_type').val('-1');
          	  	}
        		if (COSTCO.util.isUSBDStore() && shipModeDescription === messages.ACTION_ORDER_PICKUP) {
        			isValid = isValid && OrderSummary.validateMinimumThreshold();
        		}
        	}
        	
        	if(isValid && typeof COSTCO.unifiedapplepay != 'undefined' && COSTCO.unifiedapplepay.isUnifiedApplePayEnabled() && COSTCO.unifiedapplepay.isApplePaySelected()){
        		COSTCO.OrderSummary.prepareCheckoutPaymentFormForOrderSubmit();
        		$('.order-ajax').removeClass('ajax-busy');
    	        $('input[name=place-order]').attr('disabled', false);
    	        createUnifiedTokenSessionId();
        		return true;
        	} else if(isValid && typeof COSTCO.unifiedapplepay != 'undefined' && !COSTCO.unifiedapplepay.isUnifiedApplePayEnabled() && (COSTCO.applepay.isApplePaySelected() || COSTCO.applepay.isApplePayApplied() || COSTCO.applepay.isApplePayUsed())){
        		COSTCO.applepay.prepareApplePayPaymentFormForOrderSubmit();
    			$('.order-ajax').removeClass('ajax-busy');
    	        $('input[name=place-order]').attr('disabled', false);
    	        COSTCO.applepay.renderPaymentSheet();
    	        return true;
    		}
        	
        	if(isValid){
                // handle accertify fraud check failure (STRY0192563): disable fraudStatic so that user can proceed, but pass failure info to backend
                if (!creditcard.isCybersourceEnabled() && window.collector === undefined && $('form#CheckoutReviewForm').length) {
                  window.fraudStatic.enabled = false;
                  $('form#CheckoutReviewForm').append('<input type="hidden" name="fraudCheckFailed" value="true">');
                }
        		fraud.call(creditcard.isCybersourceEnabled(), function() {
        			COSTCO.OrderSummary.prepareCheckoutPaymentFormForOrderSubmit();
        			let creditCardInfoChanged = (creditcard.isPaymentEditAreaVisible() && creditcard.isSelected())
        			|| (creditcard.isApplied() && (!creditcard.isCybersourceEnabled() && hasCashCard) && $('input[name=walletCheckout]').val() === 'false');
        			if ((creditCardInfoChanged) && OrderSummary.checkPaymentRadioSelection()) {
        				if(COSTCO.accertifyThreeDS.isEnabled()) {
        					$('#threedsPlaceOrder').val('true');
        				}     				
        				if(creditcard.is3DSPaymentAuthEnabled()){
        					TokenGateway.updateSessionFromForm('card', function (response) {
    					    	TokenGateway.create3DSPaymentAuth(response,	function (){
    					            let creditCardFormValid = true;
    					            if (creditcard.isSelected()) {
    					            	creditCardFormValid = creditcard.isCybersourceEnabled()
    					                    ? creditcard.validate.creditCardForm(true)
    					                    : creditcard.validate.creditCardForm();
    					            }
    					            if (creditCardFormValid) {
    					            	var caMasterCardThreeDSFlow = COSTCO.CreditCard.forms.creditCardForm().find('input[name=caMasterCardFlow]').val() === "true";
    			        				 if(caMasterCardThreeDSFlow){
    			        					 COSTCO.OrderSummary.submitPaymentTokenfor3DSCard(function () {
    			        						 COSTCO.OrderSummary.submitPaymentTokenWithCard();
         					            	});
    			        				 }else{
    			        					 COSTCO.OrderSummary.submitPaymentTokenWithCard();
    			        				 }   
    					            } else {
    					                $('.order-ajax').removeClass('ajax-busy');
    					                $('input[name=place-order]').attr('disabled', false);
    					                $('html, body').animate({
    					                    scrollTop: ($('#CheckoutPaymentForm').offset().top)
    					                }, 100);
    					            }
    					        });
    					    },
    					    'CheckoutPaymentForm'
    					);	
        				}else{
    					TokenGateway.updateSessionFromForm('card', function () {
		        			let creditCardFormValid = true;
		    				if(creditcard.isSelected())
		    					creditCardFormValid = creditcard.isCybersourceEnabled() ? creditcard.validate.creditCardForm(true) : creditcard.validate.creditCardForm();
		    				if(creditCardFormValid){
			    				COSTCO.OrderSummary.submitPaymentTokenWithCard();
		    				}
		    				else{
		    					$('.order-ajax').removeClass('ajax-busy');
		    					$('input[name=place-order]').attr('disabled', false);
		    					$('html, body').animate({
		    					    scrollTop: ($('#CheckoutPaymentForm').offset().top)
		    					},100);
		    				}
		        			}, 'CheckoutPaymentForm');
        				}	
        			}
        			else if (OrderSummary.isCheckOnDeliverySelected() || (OrderSummary.isCheckOnDeliveryUsed() && hasCashCard)) {
        				$('input[name=payMethodId]').val('Check');
        		    	COSTCO.OrderSummary.submitPaymentTokenWithCOD();
        			}
        			else if (OrderSummary.isACHPaymentSelected() || (OrderSummary.isACHPaymentUsed() && hasCashCard)) {
        				
        				if($('#ach_account_type').val() == '-1'){
        					$('#ach_account_type').val('');
                  	  	}
                  	  
                  	  	if (typeof(TokenGateway.fieldsParam[0].ach) == 'undefined') {
                  	  		COSTCO.OrderSummary.submitPaymentTokenWithCOD();
                  		  
	              	    } else {
	              		    TokenGateway.updateSessionFromForm('ach', function() {
	          	    	  	  COSTCO.OrderSummary.submitPaymentTokenWithCOD(); 
	          	    	    }, 'CheckoutPaymentForm');
	              		    return false;
	              	    }
        			}
        			else if(OrderSummary.isARPaymentSelected()  || (OrderSummary.isARPaymentUsed() && hasCashCard)){
        				$('input[name=payMethodId]').val('LineOfCredit');
        				COSTCO.OrderSummary.submitPaymentTokenWithCOD();
        			}
        			else{
        				if (creditcard.isApplied() && COSTCO.accertifyThreeDS.isEnabled() && COSTCO.accertifyThreeDS.isCardSupported()) {
        					if (COSTCO.accertifyThreeDS.hasPreProcessError()) {
        						COSTCO.accertifyThreeDS.removeStorageSession();
    							document.CheckoutReviewForm.submit();  
        					} else {
        						COSTCO.accertifyThreeDS.processAuthentication().then(function(res){
            						COSTCO.accertifyThreeDS.removeStorageSession();
        							document.CheckoutReviewForm.submit();
        						}).catch(function(res){
        							res = COSTCO.accertifyThreeDS.getErrorString(res);
        							var threedsErrorJson = {supportedCard: true, errorCode: res};
    					    		$('input[name=threedsParams]').val(JSON.stringify(threedsErrorJson));
    					    		COSTCO.accertifyThreeDS.removeStorageSession();
        							document.CheckoutReviewForm.submit();
        						});
        					}
        				} else {
        					document.CheckoutReviewForm.submit();
        				}
        			}   
        		});
        	}
        	else {
        		$('.order-ajax').removeClass('ajax-busy');
    	        $('input[name=place-order]').attr('disabled', false);
        	}
		}
    },
    submitOrder: function() {
    	var isValid = true;
    	var isVaidCalendar=true;
    	if($('#isBDAppVar').val() == 'BD'){
    		
    		var shipmodeDescription = $("#shipmodeDescription").val();
    		
    		var isValidDate = OrderSummary.validateDate();
    		if(isValidDate){
    			
    			if ((OrderSummary.validateQuantity() || checkout_helper.isReviewPage()) && OrderSummary.checkPaymentRadioSelection()) {
	    			if (OrderSummary.validateMembershipRequired()) {
	    				
	    				if (shipmodeDescription !== 'Pick-Up') {
		    				var address = window['chosenShippingAddress'];
			    			$('#formreview').find('[name=zipCodeFormDeliveryZipCode]').val(address.zip);
			    			COSTCO.zipCodeModal.submitZipCodeForValidation($('#formreview'), COSTCO.CAddress.addressValidateSuccessOnPlaceOrder, COSTCO.CAddress.addressSetZipSuccess, address.id, undefined, address);

	    				} else {
	    					
	    					var storePickupZipCode = $("#WC_BusinessDeliveryBrowseForm_FormInput_currentZipCode").val();
	    					var storePickupCountryAndState = $("#storePickupCountryAndState").val();
	    					
	    					COSTCO.ziphelper.setZipCookie(storePickupZipCode); // i.e. 99515-1903
	    					COSTCO.ziphelper.setLocationCookie(storePickupCountryAndState); // i.e. USAK

	    					let companyName = $("#companyNameId").val();
	    					$("#companyNameReviewForm").val(companyName);
	    					
	    					COSTCO.OrderSummary.placeOrder();
 					
	    				}
	    				
	    			}
    			}
    		}
    	} else {
    		$('#hasShipChargeChanged').val($('#markShipChargeChange').val());
    		if (OrderSummary.checkPaymentRadioSelection()) {
		        //check for alcohol terms if present
		    	if ($('#alcoholTermsErrCont').length > 0 && $('#alcoholTermsDiv').length > 0) {
		    		isValid = OrderSummary.ageRestrictionTermsValidator.isValid('ALCOHOL_RESTRICTION');
		    	}
		    	if ($('#tobaccoTermsErrCont').length > 0 && $('#tobaccoTermsDiv').length > 0) {
		    		isValid = OrderSummary.ageRestrictionTermsValidator.isValid('TOBACCO_RESTRICTION');
		    	}
		    	if(this.hasTires && ($('#edit-tires-contact-information-phone input[id^=tiresSmsPhoneId_]').length > 0 && $('#tires-contact-information-phone').hasClass('hide') || 
		    			($('[id^=tires-mobile-phone-input_] .tireSmsCheckPhoneInput').length > 0 && $('[id^=edit-tires-contact-information-phone] input[id^=tireSmsCheckPhoneId_]').prop('checked')))) {
		    		let form = $('[id^=edit-tires-contact-information-phone] input[id^=tiresSmsPhoneId_]').closest("form").attr('id');
		    		isValid = OrderSummary.smsValidator.isValid($("#"+form), "[id^=edit-tires-contact-information-phone] input[id^=tiresSmsPhoneId_]");
	    		}
		    	
		    	if($("#ShopCartForm .smsPhoneInput").length > 0 ) {
			    	$("#ShopCartForm .smsPhoneInput").each(function() {
			    		
			    		let isValidEachInput = OrderSummary.smsValidator.isValid($("#ShopCartForm"), '#'+this.id);
			    		if(isValidEachInput == false) {
			    			isValid = false;
			    		} 
			    	});
		    	} else {
		    		if(($('[id^=mobile-phone-input_] .smsCheckPhoneInput').length > 0 && $('[id^=edit-contact-information-phone] input[id^=smsCheckPhoneId_]').prop('checked')) || ($('[id^=mobile-phone-input_] .smsPhoneInput').length > 0 && $('[id^=mobile-phone-input_] .smsPhoneInput').text().length > 0)) {
		    			isValid = OrderSummary.smsValidator.isValid($("[id^=mobile-phone-input_]"), 'input[id^=smsPhoneId_]');
		    		}
		    	}

		        if(isValid && COSTCO.OrderItems.validateScheduledDeliveryDate() && COSTCO.OrderItems.validateScheduledDeliveryDateEmpty() && COSTCO.OrderItems.validateAddressAvailable()
		        		&& $('#hasPickUpError').val() != 'true'){
		    		OrderSummary.placeOrder();
		        }
	    	}
    	}
    },
    
    selectedDateForBDCA: function() {
    	return $('#delivery-options-nd-off-display').length > 0 && !$('#delivery-options-nd-off-display').hasClass('hide') ? $('#ship-date-nd-off-display').html().trim() : "";
    },
    
    validateDate: function(){
    	var isValid = true;
    	var shipmodeId = 10101;
    	if(COSTCO.util.isNdEnabled() && $('input[name="deliveryMethod"]').length>0){
    		shipmodeId = $('input[name="deliveryMethod"]:checked').val();
    	}
    	if(shipmodeId == '10101' || shipmodeId == '10101_SP'){
    		var inputDate = $('input#deldatepicker').val() || $('input#deldatepicker').attr('value') || COSTCO.OrderSummary.selectedDateForBDCA();
    		if(inputDate == ''){
    			if(costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE || costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE) {
    				$('#deliveryDatePageError').html(COSTCO.util.createErrorAdaLabel(messages.MA_DELIVERYDATEERROR));
    				$('#deliveryDatePageError').css("display", "inline-block");
    				$('#deldatepicker').addClass("error");
    				$('label[for="deldatepicker"]').addClass("active error");
    				$('html, body').scrollToElem($('.selection-box-v2.local-delivery'), 200);
        			$('#deldatepicker').focus();
    			} else {
    				$('label[for="deldatepicker"]').text(messages.MA_DELIVERYDATEERROR);
    				$('label[for="deldatepicker"]').css("display", "inline-block");
    			}
    			isValid = false;
    		}
    	}
    	return isValid;
    },
    validatePoNotes: function() {
      return $('#po-notes-facade-form').valid();
    },
    /**
	* This function is used to open edit block for Customer Po/Notes
	*/
    showCustomerPoNotes: function () {
    	$('#customer-po-notes-text').addClass('hide');
    	$('#edit-customer-po-notes-text').removeClass('hide');
    	$('#edit-customer-po-notes-text input[id=po-notes-facade]').focus();
    	$('#edit-customer-po-notes-text input[id=po-notes-facade]').select();
    },

    /** this function is used for checking if the Po notes is added/updated
     */
    needsToUpdatePoNotes: function () {
        return $('#isBDAppVar').val() == 'BD' && $('#changedPoNotes').val();
    },
    /**
     * This function is used to set the flag for storing PO notes in DB
     */
    poNotesChanged: function() {
       $('#changedPoNotes').val('true');
    },
    /**
    * This function is used to open edit block for Customer Po/Notes
    */
    updateCustomerPoNotes: function () {
        let poNotes = $('#po-notes-facade').val();
        let orderId = $('input[name=orderId]').val();
        ajaxmodular.ajax_update_state({
            url: '/AjaxUpdateCustomerPoNotesCmd',
            method: "POST",
            data: {
              poNotes: poNotes,
              orderId: orderId
            }
        })
        $('#changedPoNotes').val(false);
    },
    addValidationToPoNotes: function() {
    	$.validator.addMethod('regx', function(value, element, regex) {
			return regex.test(value);
		});
        let settings = {
          rules: {
            'poNotes': {
              regx: /^(\w|\s|[(-;])*$/, // Alphanumeric, white spaces, and ( to ;
              maxlength: 50,
            }
          },
          messages: {
            'poNotes': {
              regx: function() {
                // Display invalid characters to user.
                let poNoteInvalidCharRegex = /[^\w|\s|(-;]/g; // Anything other than alphanumeric, white spaces, and ( to ;
                let poNote = $('#po-notes-facade').val();
                let regexExec;
                let message = messages._ERR_PONOTE_INVALID_CHARACTERS.split(', ')[0];
                message += ':';
                while (regexExec = poNoteInvalidCharRegex.exec(poNote)) {
                  message += ' ' + regexExec[0];
                }
                message += ', ' + messages._ERR_PONOTE_INVALID_CHARACTERS.split(',')[1];
                return message;
              },
              maxlength: messages._ERR_PONOTE_MAXLENGTH_EXCEEDED,
            }
          }
        };
        $('#po-notes-facade-form').validate(settings)
    },
    validateQuantity: function(){
    	if (($('[id^=errquantity_]').text().length == 0) && (($(".error-qty-increment")).text().length == 0)){
    		return true;
    	}else{
    		return false;
    	}
    },
	/**
	 * This object creates a validation object for age restriction.
	 */
    ageRestrictionTermsValidator : {
    	form : () => OrderSummary.ageRestrictionTermsValidator.settings.ageRestrictionName === 'ALCOHOL_RESTRICTION' ? $('#formAlcoholTerms') : $('#formTobaccoTerms'),
    	isValid : (ageRestrictionName) => {
    		let self = OrderSummary.ageRestrictionTermsValidator;
    		OrderSummary.ageRestrictionTermsValidator.settings.ageRestrictionName = ageRestrictionName;
    		let form = self.form(ageRestrictionName);
    		if (form && form.length > 0) {
    			form.destroyValidator(form.validate());
    			form.validate(self.settings);
    			//add rules
    			formInput = ageRestrictionName === 'ALCOHOL_RESTRICTION' ? 'input[name=alcoholTerms]' : 'input[name=tobaccoTerms]';
    			form.find(formInput).rules('add', {
    				required : true
    			});
    			return form.valid();
    	}
    	return true;
    	},
    	toggleError : (element, hasError) => {
        let termsDiv = OrderSummary.ageRestrictionTermsValidator.settings.ageRestrictionName === 'ALCOHOL_RESTRICTION' ? '#alcoholTermsDiv' : '#tobaccoTermsDiv';
        let parent = element.closest(termsDiv);
        let errorContainer = parent.find(".checkout-container-body");
        let errorHolder = parent.find(".error-message-critical");
        let termsErrorContainer = OrderSummary.ageRestrictionTermsValidator.settings.ageRestrictionName === 'ALCOHOL_RESTRICTION' ? "#alcoholTermsErrCont" : "#tobaccoTermsErrCont";
        let globalErrorHolder = $(termsErrorContainer);
        if (hasError) {
        	let termsSRError = OrderSummary.ageRestrictionTermsValidator.settings.ageRestrictionName === 'ALCOHOL_RESTRICTION' ? 'alcoholTermsSRError' : 'tobaccoTermsSRError';
        	errorContainer.addClass("checkbox-text-error-box");
        	$(termsDiv).find('.form-age-restriction-terms-container').addClass("critical-notification-restriction");
        	errorHolder.removeClass("hidden");
        	globalErrorHolder.removeClass("hidden");
        	$(termsDiv).find('input').attr('aria-invalid','true');
        	$(termsDiv).find('input').attr('aria-describedby',termsSRError);
        	let errorData = [];
        	let errorText = OrderSummary.ageRestrictionTermsValidator.settings.ageRestrictionName === 'ALCOHOL_RESTRICTION' ? messages.ALCOHOL_TERMS_ERR_MSG : messages.TOBACCO_TERMS_ERR_MSG;
        	errorData.push(errorText);
        	if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE === true) {
        		COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR, errorData, true);
        	}
        	$(termsDiv).find('input').focus();
        } else {
        	errorContainer.removeClass("checkbox-text-error-box");
        	$(termsDiv).find('.form-age-restriction-terms-container').removeClass("critical-notification-restriction");
        	errorHolder.addClass("hidden");
        	$(termsDiv).find('input').removeAttr('aria-invalid');
        	$(termsDiv).find('input').removeAttr('aria-describedby');
        	globalErrorHolder.addClass("hidden");
        }
    },
	settings : {
		errorPlacement: function (error, element) {
			let self = OrderSummary.ageRestrictionTermsValidator;
			let validator = self.form().validate();
			if (Object.keys(validator.invalid).length > 0) {
				self.toggleError(element, true);
			}
		},
		success : function (error, element) {
			let self = OrderSummary.ageRestrictionTermsValidator;
			let validator = self.form().validate();
			if (Object.keys(validator.invalid).length === 0) {
				self.toggleError($(element), false);
				if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE === true) {
					COSTCO.util.notification.clearNotification();
				}
			}
		},
		invalidHandler : function(event, validator) {
			if (!validator.numberOfInvalids()) {
				return;
			}
			if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE !== true) {
				setTimeout(() => {
					$('html, body').animate({
						scrollTop: $(event.currentTarget).closest(".checkout-container-body").offset().top - 100
					});
				});
			}
		},
		ageRestrictionName : 'NO_RESTRICTION',
		}
	},

	/**
     * This object creates a validation object for sms for tires.
     */
	smsValidator : {
		validationRulesApplied : false,

		validationRules : () => {
			if(!OrderSummary.smsValidator.validationRulesApplied) {
				$.validator.addMethod("contactPhone", function( value, element ) {
					if (value.startsWith("0") || value.startsWith("1")) {
						return false;
					}
					return this.optional(element) || /^\(?\d{3}\)?[ -.]?\d{3}[ -.]?\d{4}$/.test(value);
				}, messages.ERR_INVALID_PHONE1);
			}

			OrderSummary.smsValidator.validationRulesApplied = true;
		},

		isValid : (form, identifier) => {
			let self = OrderSummary.smsValidator;
			self.validationRules();
			if(form && form.length > 0) {
				form.validate(self.settings);
				//add rules
				let id= $('[class^="mobile-phone-input"]').closest("form").attr('id');
				if(id.includes("mobile-phone-input")){
					form.find(identifier).rules('add', {
						contactPhone : true,
						required: true,
						messages: {
							required: messages.CHECKOUT_RECEIVE_SMS_PHONE_NUMBER_ERROR,
							
						}					
					});
				}else{
					form.find(identifier).rules('add', {
						contactPhone : true,
						messages: {
							required: messages.ERR_INVALID_PHONE1,
						}
					});
				}
				return form.valid();
    		}
    		return true;
		},
	    settings : {
			invalidHandler : function(event, validator) {
	  		  if (validator.numberOfInvalids()) {
	  		    validator.errorList[0].element.focus();
				}
	      },
			highlight: COSTCO.util != undefined ? COSTCO.util.highlightWithErrorLabel : () => {},
			unhighlight: COSTCO.util != undefined ? COSTCO.util.unhighlightWithErrorLabel : () => {},
			errorPlacement: function errorPlacement(error,element){
				let id= $('[class^="mobile-phone-input"]').closest("form").attr('id');
				if(id.includes("mobile-phone-input_")){ 
					let formInput = $('[id^=mobile-phone-input_] .smsPhoneInput').length;
						if(formInput > 0){
						//element.parent().addClass('error');						
						error.insertAfter($('[id^=optinError]')).append(error.css({"line-height" : 1.5}));						
						
					}else if(!formInput > 0){
						//element.parent().addClass('error');								
						error.insertAfter($('[id^=tireOptinError]')).append(error.css({"line-height" : 1.5}));						
					}
					
				} else {
					error.insertAfter(element);
				}
						
			}
		}
	}, 
	
    /**
	 *	Validation definition with rules and masking
	 */
    smsPhoneValidatior: function() {
		
		// Validation rules
    	$.validator.addMethod("contactPhone", function( value, element ) {
			if (value.startsWith("0") || value.startsWith("1")) {
				return false;
			}
			return this.optional(element) || /^\(?\d{3}\)?[ -.]?\d{3}[ -.]?\d{4}$/.test(value);
		}, messages.ERR_INVALID_PHONE1);
		
		$("[id^='mobile-phone-input']").validate({
	
			// Specify validation rules
			rules: {
			  membershipNum: {
				  costcoMembership: true
			  }
			},
			
			isValid: function(form) {
				emailPopup.signup();
			}.bind(this)
			});
		
	    },
	
    /**
     * Function to send the shipping address for a given order
     * Will first perfom validation on the membership number first for warehouse pickup
     * the or clause is there to short circuit the logic if a membership number is already there
     */
    submitShipping: function(submitAddressStepCallback, preventajaxreload = true) {
    	var isValid = true;
    	if ($('#isBDAppVar').val() == 'BD') {
    		isValid = OrderSummary.validateDate();
    		if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE !== true) {
    			isValid = isValid && OrderSummary.validatePoNotes();
    		}
    	} else if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE !== true) {
    		if ($('#alcoholTermsDiv').length > 0) {
    			isValid = OrderSummary.ageRestrictionTermsValidator.isValid('ALCOHOL_RESTRICTION');
    		}
    		if ($('#tobaccoTermsDiv').length > 0) {
    			isValid = OrderSummary.ageRestrictionTermsValidator.isValid('TOBACCO_RESTRICTION');
    		}
        }
    	if(costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE !== true && this.hasTires && $('[id^=tires-mobile-phone-input_] .tireSmsCheckPhoneInput').length > 0 && $('[id^=edit-tires-contact-information-phone] input[id^=tireSmsCheckPhoneId_]').prop('checked')) {
    		let form = $('[id^=edit-tires-contact-information-phone] input[id^=tiresSmsPhoneId_]').closest("form").attr('id');  
    		isValid = OrderSummary.smsValidator.isValid($("#"+form), "[id^=edit-tires-contact-information-phone] input[id^=tiresSmsPhoneId_]");
    	}
    	
    	if(costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE !== true && $("#ShopCartForm .smsPhoneInput").length > 0 ) {
			$("#ShopCartForm .smsPhoneInput").each(function() {
	    		let form = $(this).closest("form").attr('id');
	    		let isValidEachInput = OrderSummary.smsValidator.isValid($("#"+form), '#'+this.id);
	    		if(isValidEachInput == false) {
	    			isValid = false;
	    		} 
	    	});
    	} else {
    		if($('[id^=mobile-phone-input_] .smsCheckPhoneInput').length > 0) {    			
    			if($('[id^=edit-contact-information-phone] input[id^=smsCheckPhoneId_]').prop('checked')){
    				isValid = OrderSummary.smsValidator.isValid($("[id^=mobile-phone-input_]"), 'input[id^=smsPhoneId_]');
    			}
    			
    	}
    	}
    	
    	if(isValid){
    		// Stop user from moving forward if order require membership but its not linked
    		if (OrderSummary.validateMembershipRequired()) {

    			if (addressForm.isFormCompleted('S') || orderStatic.isShipToWarehouseOrder) {
    				let id = addressForm.getShippingId();
    				if ($('#isBDAppVar').val() == 'BD') {
    					var address = window['chosenShippingAddress'];
    					let form = costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE ? $('#formreview') : $('#formshipping');
	    				form.find('[name=zipCodeFormDeliveryZipCode]').val(address.zip);
	    				COSTCO.zipCodeModal.submitZipCodeForValidation(form, COSTCO.CAddress.addressValidateSuccessOnSubmitShipping, COSTCO.CAddress.addressSetZipSuccess, address.id, undefined, address);
    				}else{
    					$('#NewAddressSingleShippingForm input[name="addressId"]').val(id);
    					$('#NewAddressSingleShippingForm').submit();
    				}
    			} else if (addressForm.validate('S')) {
    				if ($('#isBDAppVar').val() == 'BD') {
    					addressForm.submit('S', preventajaxreload, undefined);
    				}else{
    					$('body').bind('costco.address.added', function(event, address) {
    						$('#NewAddressSingleShippingForm input[name="addressId"]').val(address.addressId);
    						$('#NewAddressSingleShippingForm').submit();
              
    					});
    					addressForm.submit('S', preventajaxreload, undefined);
    				}
    			}
    		}
    	}
    },
    submitMultiShipping: function() {
      if (OrderSummary.validateMembershipRequired()) {
        if ($('.error_check').length === 0) {
        	var isValid = true;
          if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE !== true) {
            if ($('#alcoholTermsDiv').length > 0) {
              isValid = OrderSummary.ageRestrictionTermsValidator.isValid('ALCOHOL_RESTRICTION');
            }
            if ($('#tobaccoTermsDiv').length > 0) {
              isValid = OrderSummary.ageRestrictionTermsValidator.isValid('TOBACCO_RESTRICTION');
            }
          }
          if(isValid){
            $('#NewAddressSingleShippingForm').submit();
	        }
        } else {
          $(window).scrollTop(0);
        }
      }
    },
    validateMembershipRequired: function() {
    	if($('#isBDAppVar').val() == 'BD'){
    		if (orderStatic.orderRequireMembership){
    			if (!orderStatic.currentOrderHasMembershipNo){
    				let errorContainer = $('#membership-number-error');
    				errorContainer.empty();
    				errorContainer.append(messages.ERR_BD_REQUIRE_MEMBERSHIP);
    				return false;
    			}
    		}

    	}
    	else if (orderStatic.isShipToWarehouseOrder) {
    		 if (orderStatic.orderRequireMembership) {
		        if (!(orderStatic.currentOrderHasMembershipNo || orderStatic.currentXOrderHasMembershipNo)) {
		          let errorContainer = $('#membership-number-error');
		          errorContainer.empty();
		          errorContainer.append(messages.ERR_WAREHOUSE_PICKUP_REQUIRE_MEMBERSHIP);
		          OrderSummary.editMembership();
		          return false;
		        }
    		}
      }
      return true;
    },
    isMembershipPurchaseOptinSelected: function(){
    	var isOptedIn = false;
    	
    	if(costcoStoreFeatures.MEMBERSHIP_CHECKOUT_AUTO_RENEW_OPTION_ENABLED !== 'undefined'
			&& costcoStoreFeatures.MEMBERSHIP_CHECKOUT_AUTO_RENEW_OPTION_ENABLED && 
			($('input[name="isQuickPurchase"]') !== undefined && $('input[name="isQuickPurchase"]').val() === 'true' 
				|| $('input[name="isQuickPurchaseFlow"]') !== undefined && $('input[name="isQuickPurchaseFlow"]').val() === 'true')
				&& $("input[name='radio-auto-renew']:checked").val() !== undefined && $("input[name='radio-auto-renew']:checked").val() == 'optin'){
    		isOptedIn = true;
    	}
    	
    	return isOptedIn;
    },
    /**
     * Submit for review with wallet checkout module enabled
     */
    submitForReviewWithWallet: function(validateAddress) {
    	if($('#autoRenewGenericError').length > 0) {
    		$('#autoRenewGenericError').addClass('hide');
    	}
    	if(costcoStoreFeatures.MEMBERSHIP_CHECKOUT_AUTO_RENEW_OPTION_ENABLED !== 'undefined'
    						&& costcoStoreFeatures.MEMBERSHIP_CHECKOUT_AUTO_RENEW_OPTION_ENABLED && $('input[name="isQuickPurchase"]') !== undefined 
    						&& $('input[name="isQuickPurchase"]').val() === 'true' && $("input[name='radio-auto-renew']:checked").val() === undefined){
    		$('#membership-renew-error-container').removeClass('hide');
    		$('#membership-renew-selection-error').removeClass('hide');
    		$('#membership-renew-selection-error').focus();
    		$('body, html').animate({
                scrollTop: $('#membership-renew-selection-error').offset().top - 100,
             }, 500);
    	}else{
	    	var isValid = true;
	        //check for live tickets terms if present and validate is it checked
	    	if(typeof $('#live-tickets-order-agreement') !== 'undefined' && $('#live-tickets-order-agreement').length > 0){
	    		isValid = OrderSummary.validateLiveTicketsOrderAgreement();
	    	}
	    	if($('#isBDAppVar').val() == 'BD'){
	    		isValid = OrderSummary.validateMembershipRequired();
	    		if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE !== true) {
	    			isValid = isValid && OrderSummary.validatePoNotes();
	    		}
	    		//reset ach dropdown value
	    		if($('#ach_account_type').val()==null || $('#ach_account_type').val() == ''){
	      		  $('#ach_account_type').val('-1');
	      	  }
	    	}
	
	        if (isValid) {
	        	
	        	// Disable fraudStatic so that user can proceed, but pass failure info to backend
	            if (!creditcard.isCybersourceEnabled() && window.collector === undefined && $('form#CheckoutPaymentForm').length && window.fraudStatic.enabled == true) {
	                window.fraudStatic.enabled = false;
	                $('form#CheckoutPaymentForm').append('<input type="hidden" name="fraudCheckFailed" value="true">');
	              }
	        	
	            if (OrderSummary.isAllPaidByCashCard()) {
	                checkout_helper.show_busy_indicator();
	                if(OrderSummary.isMembershipPurchaseOptinSelected()){
	                	TokenGateway.updateSessionFromForm('card', function() {
                            COSTCO.OrderSummary.submitPaymentToken(validateAddress);
                        }, 'CheckoutPaymentForm');
	                }else{
	                	COSTCO.OrderSummary.submitPaymentToken(!OrderSummary.isAllPaidByCashCard() || costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE);
	                }
	            } else if (OrderSummary.isCheckOnDeliverySelected() || (!OrderSummary.hasPaymentSelectionChanged() && OrderSummary.isCheckOnDeliveryUsed())
	            		|| (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE && OrderSummary.isCheckOnDeliveryApplied())) {
	                $('input[name=payMethodId]').val('Check');
	                checkout_helper.show_busy_indicator();
	                COSTCO.OrderSummary.submitPaymentTokenWithCOD(costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE && hasCashCard);
	
	            } else if (OrderSummary.isACHPaymentSelected() || (!OrderSummary.hasPaymentSelectionChanged() && OrderSummary.isACHPaymentUsed())
	            		|| (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE && OrderSummary.isACHPaymentApplied())) {
	                checkout_helper.show_busy_indicator();
	                if($('#ach_account_type').val() == '-1') {
	                    $('#ach_account_type').val('');
	                }
	
	                if (typeof(TokenGateway.fieldsParam[0].ach) == 'undefined') {
	                    COSTCO.OrderSummary.submitPaymentTokenWithCOD(costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE && hasCashCard);
	                } else {
	                    TokenGateway.updateSessionFromForm('ach', function() {
	                        COSTCO.OrderSummary.submitPaymentTokenWithCOD(costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE && hasCashCard);
	                    }, 'CheckoutPaymentForm');
	                    return false;
	                }
	
	            } else if (OrderSummary.isARPaymentSelected() || (!OrderSummary.hasPaymentSelectionChanged() && OrderSummary.isARPaymentUsed())
	            		|| (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE && OrderSummary.isARPaymentApplied())) {
	                checkout_helper.show_busy_indicator();
	                COSTCO.OrderSummary.submitPaymentTokenWithCOD(costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE && hasCashCard);
	
	            } else if(typeof COSTCO.unifiedapplepay != 'undefined' && COSTCO.unifiedapplepay.isApplePaySelected() || (!OrderSummary.hasPaymentSelectionChanged() && COSTCO.unifiedapplepay.isApplePayUsed()) 
	            		|| (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE && COSTCO.unifiedapplepay.isApplePayApplied())) {
	                checkout_helper.show_busy_indicator();
	                COSTCO.unifiedapplepay.submitPaymentStep();
	
	            } else if(applepay.isApplePaySelected() || (!OrderSummary.hasPaymentSelectionChanged() && applepay.isApplePayUsed()) 
	            		|| (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE && applepay.isApplePayApplied())) {
	                checkout_helper.show_busy_indicator();
	                COSTCO.applepay.submit.applePayForm();
	
	            }else {
	                // handle accertify fraud check failure (STRY0192563): disable fraudStatic so that user can proceed, but pass failure info to backend
	                if (!creditcard.isCybersourceEnabled() && window.collector === undefined && $('form#CheckoutPaymentForm').length) {
	                  window.fraudStatic.enabled = false;
	                  $('form#CheckoutPaymentForm').append('<input type="hidden" name="fraudCheckFailed" value="true">');
	                }
	                fraud.call(creditcard.isCybersourceEnabled(), function() {
	                    if (OrderSummary.checkPaymentRadioSelection()) {
	                    	var cardAuthentication = false;
	                    	if (COSTCO.accertifyThreeDS.isEnabled() && typeof checkoutPage !== 'undefined' 
	                    		&& (checkoutPage === 'quick-membership' || checkoutPage === 'quick-membership-renew')) {
	                    		cardAuthentication = true;
	                    	}
	                        if (wallet.isSelected() || wallet.isUsed()) {
	                        	if (cardAuthentication && COSTCO.accertifyThreeDS.isCardSupported()) {
	                        		if (COSTCO.accertifyThreeDS.hasPreProcessError()) {
	            						COSTCO.accertifyThreeDS.removeStorageSession();
	            						creditcard.submit.creditCardForm(); 
	            					} else {
	            						COSTCO.accertifyThreeDS.processAuthentication().then(function(res){
	                						COSTCO.accertifyThreeDS.removeStorageSession();
	                						creditcard.submit.creditCardForm();
	            						}).catch(function(res){
	            							res = COSTCO.accertifyThreeDS.getErrorString(res);
	            							var threedsErrorJson = {supportedCard: true, errorCode: res};
	        					    		$('input[name=threedsParams]').val(JSON.stringify(threedsErrorJson));
	        					    		COSTCO.accertifyThreeDS.removeStorageSession();
	        					    		creditcard.submit.creditCardForm();
	            						});
	            					}
	            				} else {
	            					creditcard.submit.creditCardForm();
	            				}
	                        } else {
	                            checkout_helper.show_busy_indicator();
	                            if (cardAuthentication) {
	                            	$('#threedsPlaceOrder').val('true');
	                            	TokenGateway.updateSessionFromForm('card', function() {
	                                    COSTCO.OrderSummary.submitPaymentTokenWithCard(validateAddress);
	                                }, 'CheckoutPaymentForm');
	                            } else if (creditcard.isCybersourceEnabled() 
		                            && creditcard.isSelected() && creditcard.isCCEditAreaHidden()) {
	                                COSTCO.OrderSummary.submitPaymentToken(validateAddress);
	                            } else {
                                    if(creditcard.is3DSPaymentAuthEnabled() && creditcard.is3DSMemberCheckoutEnabled()){
                                        TokenGateway.updateSessionFromForm('card', function (response) {
                                            TokenGateway.create3DSPaymentAuth(response,    function (){
                                                let creditCardFormValid = true;
                                                if (creditcard.isSelected()) {
                                                    creditCardFormValid = creditcard.isCybersourceEnabled()
                                                        ? creditcard.validate.creditCardForm(true)
                                                        : creditcard.validate.creditCardForm();
                                                }
                                                if (creditCardFormValid) {
                                                    var caMasterCardThreeDSFlow = COSTCO.CreditCard.forms.creditCardForm().find('input[name=caMasterCardFlow]').val() === "true";
                                                    if(caMasterCardThreeDSFlow){
                                                         COSTCO.OrderSummary.submitPaymentTokenfor3DSCard(function () {
                                                             COSTCO.OrderSummary.submitPaymentToken(validateAddress);
                                                         });
                                                     }else{
                                                         COSTCO.OrderSummary.submitPaymentToken(validateAddress);
                                                     }   
                                                }
                                            });
                                        },
                                        'CheckoutPaymentForm'
                                    );    
                                    }else{
                                        TokenGateway.updateSessionFromForm('card', function() {
                                            COSTCO.OrderSummary.submitPaymentToken(validateAddress);
                                        }, 'CheckoutPaymentForm');
                                    }
                            }
	                            return false;
	                        }
	                    }
	                });
	            }
	        }
    	}
    },

    /**
     * Submit quick membership for renew.
     * Check shipping/billing addresses with AVS, and submit to backend as temporary (status = 'T') via ajax modular.
     * If there was a tax change ajax modular will refresh widgets (top notification message and order summary) and order will not be placed
     * It there was no tax change place an order.
     * 
     * @param {boolean}   isWalletPayment True if wallet is selected as payment method
     */
    submitQuickMembershipForRenew : function(event) {
      
      let isWallet = (typeof event == 'object') ? event.data.isWalletPayment : event;
      console.log('wallet: ' + isWallet);

      let submitOrder = function() {
        let validateAddressOnPayment = false;
        if (isWallet) {
          OrderSummary.submitForReviewWithWallet(validateAddressOnPayment);        
        } else {
          OrderSummary.submitForReview(validateAddressOnPayment);
        }
      };

      let callback = function(taxChanged, refreshTokenGateway) {
        
        if (taxChanged) {
          
          if (refreshTokenGateway) {
             TokenGateway.refreshGateway();
          }
          // After callback when tax has been changed / wallet changed - 
          // Credit card flag that indicates whether validation has happened needs to be flipped to false.
          wallet.ccSectionShown = false;
          creditcard.initComplete = false;
          $('html, body').animate({
            scrollTop: 0,
          }, 300);

        } else {
          submitOrder();
        }

      }

      if (COSTCO.QuickRenewAddressHelper.isAddressChanged() || !COSTCO.QuickRenewAddressHelper.isDefaultAddress('B')) {
        
    	  if(COSTCO.QuickRenewAddressHelper.isDefaultAddress('S') && !COSTCO.MembershipHelper.isQuickMembership) {
    		  COSTCO.QuickRenewAddressHelper.openDefaultAddressChangeInfoModal(callback)
    	  } else {
    		  COSTCO.QuickRenewAddressHelper.submitAddress(callback);
    	  }
      } else if (COSTCO.QuickRenewAddressHelper.isShippingBillingAddressValid()) {
        submitOrder();
      }
    },

    /**
     * Submit for review with wallet checkout module disabled
     */
    submitForReview: function(validateAddress) {
      if (OrderSummary.isAllPaidByCashCard()) {
        checkout_helper.show_busy_indicator();
        COSTCO.OrderSummary.submitPaymentToken(validateAddress);
      } 
      else {
        checkout_helper.show_busy_indicator();
        if (COSTCO.accertifyThreeDS.isEnabled() && typeof checkoutPage !== 'undefined' 
    		&& (checkoutPage === 'quick-membership' || checkoutPage === 'quick-membership-renew')) {
        	$('#threedsPlaceOrder').val('true');
        	TokenGateway.updateSessionFromForm('card', function() {
                COSTCO.OrderSummary.submitPaymentTokenWithCard(validateAddress);
            }, 'CheckoutPaymentForm');
    	} else {
    		TokenGateway.updateSessionFromForm('card', function() {
    	          COSTCO.OrderSummary.submitPaymentToken(validateAddress);
    	        }, 'CheckoutPaymentForm');
    	}
        return false;
      }
    },
    isAllPaidByCashCard: function() {
      return ($('#outstandingPrincipal').val() == 0);
    },
    isPaymentMethodRadioSelected: function() {
      return (creditcard.isCreditCardOptionSelected() ||
    	wallet.isClickPayOptionSelected() ||
        wallet.isMasterpassOptionSelected() ||
        wallet.isVisacheckoutOptionSelected() ||
        wallet.isCheckOnDeliveryOptionSelected() || 
        OrderSummary.isACHPaymentSelected() ||
        OrderSummary.isARPaymentSelected() ||
        applepay.isApplePaySelected());
    },
    isCheckOnDeliverySelected: function() {
    	return $('input[id=radio-check]:checked').length;
    },
    isACHPaymentSelected: function() {
    	return $('input[id=radio-ach]:checked').length;
    },
    isARPaymentSelected: function() {
    	return $('input[id=radio-ar]:checked').length;
    },
    isCheckOnDeliveryUsed: function() {
    	return ($('input[id=ordPayInsVal]').length > 0 && $('input[id=ordPayInsVal]').val() == 'Check');
    },
    isACHPaymentUsed: function() {
    	return ($('input[id=ordPayInsVal]').length > 0 && $('input[id=ordPayInsVal]').val() == 'ACH');
    },
    isARPaymentUsed: function() {
    	return ($('input[id=ordPayInsVal]').length > 0 && $('input[id=ordPayInsVal]').val() == 'LineOfCredit');
    },
    isCheckOnDeliveryApplied: function() {
    	return ($('input[id=appliedPayMethod]').length > 0 && $('input[id=appliedPayMethod]').val() == 'check');
    },
    isACHPaymentApplied: function() {
    	return ($('input[id=appliedPayMethod]').length > 0 && $('input[id=appliedPayMethod]').val() == 'ach');
    },
    isARPaymentApplied: function() {
    	return ($('input[id=appliedPayMethod]').length > 0 && $('input[id=appliedPayMethod]').val() == 'ar');
    },
    submitPaymentTokenWithCOD: function(validateAddress) {
        let addressCompleted = true;
        let addressFormValid = true;

        if (validateAddress !== undefined) {
            if (validateAddress === false) {
                addressCompleted = true;
            } else {
                addressCompleted = addressForm.isFormCompleted('B');
            }
        }


        var form = COSTCO.CreditCard.forms.creditCardForm();
        let isFormValid = '';
        
        if (OrderSummary.isACHPaymentUsed() || OrderSummary.isACHPaymentSelected()) {
        	form = COSTCO.CreditCard.forms.achForm();
    		var validator = form.validate();
    		var focusPriority = 0;
        	validator.settings.errorPlacement = function(error, element) {
        		if (element.attr("name") == "ach_checkbox" ) {
                   element.closest(".row").find("[ach-checkbox-error]").append(error.css({"margin-top" : 10}));
                   element.closest(".row").find("[ach-checkbox-error]").append(error.css({"margin-bottom" : 10}));
                } else {
                	element.parent().append(error);
                }
            };
            
            validator.settings.highlight = function(element, errorClass) {
                if(element.getAttribute("id") == "ach_account_holder_validator" ) {
                	$('iframe').filter('.gw-proxy-bankAccountHolder').addClass('error-credit-card');
                	$('label[for="ach_account_holder_validator"]').removeClass('hide');
                	$('iframe').filter('.gw-proxy-bankAccountHolder').focus();
                	focusPriority = 5;
                	
                } else if(element.getAttribute("id") == "ach_routing_number_validator" ) {
                	$('iframe').filter('.gw-proxy-routingNumber').addClass('error-credit-card');
                	$('label[for="ach_routing_number_validator"]').removeClass('hide');
                	
                	if(focusPriority < 3) {
                		$('iframe').filter('.gw-proxy-routingNumber').focus();
                		focusPriority = 3;
                	}
                	
                } else if(element.getAttribute("id") == "ach_account_number_validator" ) {
                	$('iframe').filter('.gw-proxy-bankAccountNumber').addClass('error-credit-card');
                	$('label[for="ach_account_number_validator"]').removeClass('hide');
                	if(focusPriority < 2) {
                		$('iframe').filter('.gw-proxy-bankAccountNumber').focus();
                		focusPriority = 2;
                	}
                	
                } else if(element.getAttribute("id") == 'ach_account_type') {
                	$(element).addClass(errorClass);
                	if(focusPriority < 4) {
                		$(element).focus();
                		focusPriority = 4;
                	}
                	
                } else {
                	$(element).addClass(errorClass);
                	if(focusPriority < 1) {
                		$(element).focus();
                		focusPriority = 1;
                	}
                }
            };
            
            // Validate if ACH payment has been explicitly selected.
        	isFormValid = (COSTCO.CreditCard.forms.achForm().is(':visible')) ? form.valid() : true;
        	
        } else if (OrderSummary.isCheckOnDeliverySelected() || OrderSummary.isCheckOnDeliveryUsed() || OrderSummary.isARPaymentSelected() || OrderSummary.isARPaymentUsed()) {
            isFormValid = true;
        } else {
    		$('#cc_expiry_date').addClass('ignore');
        	isFormValid=form.valid();
        }
        
        if (isFormValid) {
        	fraud.call(COSTCO.CreditCard.isCybersourceEnabled(), function() {
        		if(OrderSummary.hasPaymentSelectionChanged()){
        			$('input[name=updatePayment]').val('true');
        		}
	        	if(OrderSummary.isACHPaymentSelected()){
	        		$('input[name=payMethodId]').val('ACH');
	        		
	        		$("#ach-block-form-article").clone().appendTo($("#hiddenClonedForm"));
	        		$("#ach-block-form-checkbox").clone().appendTo($("#hiddenClonedForm"));
            		$("#ach-block-form-save-default-checkbox").clone().appendTo($("#hiddenClonedForm"));
	        		
	        		//workaround as jQuery clone doesn't copy select values
	        		let accountTypeSelectedValue = $('#ach-payment-block #ach-block-form-article #ach_account_type').val();
	        		$('#hiddenClonedForm #ach-block-form-article #ach_account_type option[value=' + accountTypeSelectedValue + ']').prop('selected', true);
	        		
	        		let nameOnCard = $('#ach-payment-block #ach-block-form-article #ach_account_holder').val();
	        		$('#hiddenClonedForm #ach-payment-block #ach-block-form-article #ach_account_holder').val(nameOnCard);
	        		
	        	}else if(OrderSummary.isARPaymentSelected()){
	  	    	  $('input[name=payMethodId]').val('LineOfCredit');
	  	    	  $("#ar-block-form-article").clone().appendTo($("#hiddenClonedForm"));
	        	}
	            if (addressCompleted) {
	            	if(OrderSummary.membershipTncValidator.isValid()){
	              creditcard.submit.creditCardForm();
	            	}
	            } else {
	              if (addressFormValid) {
	            	  if(OrderSummary.membershipTncValidator.isValid()){
	                $('body').bind('costco.address.added', function(event, address) {
	                  $('input[name=place-order]').attr('disabled', true);
	                  creditcard.submit.creditCardForm();
	                });
	                if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE === true) {
	                    addressFormValid = addressForm.validate('B');
	                    if (addressFormValid === true) {
	            		  addressForm.submit('B', COSTCO.OrderSummary.preventHtmlReload);
	            	  }	                
	                } else {
	                    addressForm.submit('B', COSTCO.OrderSummary.preventHtmlReload);
	              }
	            }
            }
          }
            });
          } else {
  	    	  $('input[name=place-order]').attr('disabled', false);
  	    	  if(costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE) {
  	    		$('html, body').scrollToElem($('#billing'), 200);
  	    	  } else {
  	    		$('html, body').animate({
  	              scrollTop: 200,
  	            }, 300);
  	    	  }
          }
        
        checkout_helper.remove_busy_indicator();
      },
      submitPaymentTokenfor3DSCard : function (callback) {
          const form = document.getElementById("cardinal_collection_form");
          if (!form) {
              console.error("3DS form not found");
              return;
          }else{
        	var threeDSAccessToken =  COSTCO.CreditCard.forms.creditCardForm().find('input[name=threeDSAccessToken]').val();
      	    var threeDSDeviceCollectionUrl =  COSTCO.CreditCard.forms.creditCardForm().find('input[name=threeDSDeviceCollectionUrl]').val();
      	    form.action = threeDSDeviceCollectionUrl;
      	    var jwtInput = form.querySelector('input[name="JWT"]');
	      	  if (jwtInput) {
	      	    jwtInput.value = threeDSAccessToken; 
	      	  }
          	}
          form.submit();
          let timeoutId;
          function onCardinalResponse(event) {
              try {
                  const data = typeof event.data === "string" ? JSON.parse(event.data) : event.data;
                  if (data && data.Status === true) {
                	  console.log("3DS authentication success:", data);
                  } else {
                      console.log("3DS authentication failed:", data);
                  }
                  callback();
              } catch (err) {
            	  callback();
                  console.error("Invalid 3DS response:", err);
              } finally {
            	  clearTimeout(timeoutId);
                  window.removeEventListener("message", onCardinalResponse);
              }
          }
          timeoutId = setTimeout(() => {
              console.warn("3DS response timeout — proceeding with fallback callback.");
              window.removeEventListener("message", onCardinalResponse);
              callback();
          }, 10000);
          window.addEventListener("message", onCardinalResponse);
      },
    submitPaymentTokenWithCard: function(validateAddress) {
    	let cardType = $('input[name=payMethodId]').val();
      	if (COSTCO.accertifyThreeDS.isEnabled() && COSTCO.accertifyThreeDS.isCardSupported(cardType)) {
  			let cardNumberChanged = $('input[name=tkResNumberCapture]').val();
  			$('.order-ajax').addClass('ajax-busy');
  			if (COSTCO.accertifyThreeDS.hasPreProcessError()) {
				COSTCO.accertifyThreeDS.removeStorageSession();
				COSTCO.OrderSummary.submitPaymentToken(validateAddress);  
			} else {
	  			COSTCO.accertifyThreeDS.processAuthentication(cardNumberChanged).then(function(res){
	  				COSTCO.accertifyThreeDS.removeStorageSession();
	  				COSTCO.OrderSummary.submitPaymentToken(validateAddress);
	  			}).catch(function(res){
	  				res = COSTCO.accertifyThreeDS.getErrorString(res);
	  				var threedsErrorJson = {supportedCard: true, errorCode:res};
	  			    $('input[name=threedsParams]').val(JSON.stringify(threedsErrorJson));
	  			    COSTCO.accertifyThreeDS.removeStorageSession();
	  			    COSTCO.OrderSummary.submitPaymentToken(validateAddress);
	  			});			  
			}	  
  		} else {
  			COSTCO.OrderSummary.submitPaymentToken(validateAddress);
  		}
      },
    submitPaymentToken: function(validateAddress) {

      let addressCompleted = false;
      if (typeof validateAddress === "undefined") {
        validateAddress = true;
      } 
      
      // If it is Quick Membership Purchase (and not Quick Renew), validate address even if input parameter validateAddress is explicitly set to false
      if (COSTCO.MembershipHelper != undefined && COSTCO.MembershipHelper.isQuickMembership && $('#quick-renew-address-section').length == 0) {
        validateAddress = true;
      }
      if(typeof $('#live-tickets-container') != undefined && $('#live-tickets-container').length === 1){
    	  validateAddress = true;
      }
      
      var addressForms = addressForm.getForm();
      let addressType = 'B'
      if(addressForms.length > 0 && addressForms[0].id == 'quick-renew-address-form') {
    	  if(!addressForms.find('[name=use-different-address-for-billing]').prop('checked'))
    		  addressType = 'S';
      }

      if (validateAddress === false) {
        addressCompleted = true;
      } else {
        addressCompleted = addressForm.isFormCompleted(addressType);
      }


      
      let addressFormValid = true;

      if (!addressCompleted) {
        addressFormValid = addressForm.validate(addressType);

        if (!addressFormValid) {
          checkout_helper.remove_busy_indicator();
          $('#address-container-billing').removeClass('hide');
        }
      }
      
      if ($('#isStorePickupSelected').val() === 'true' ){
		  if($('#companyNameId').val().trim().length < 1) {
			  let errorElement = document.getElementById("company_name_validator_err_msg");
			  $(errorElement).removeClass("hide");
			  $('#companyNameId').addClass("error");
			  addressFormValid = false;
		  }
      }
      let creditCardFormValid = true;
      if(creditcard.isSelected()){
    	  creditCardFormValid = creditcard.isCybersourceEnabled() ? creditcard.validate.creditCardForm(true) : creditcard.validate.creditCardForm();
          
      } 
      
      console.log('Validation results: ' + 'addressCompleted=' + addressCompleted + ', addressFormValid=' + addressFormValid + ', creditCardFormValid=' + creditCardFormValid);
      
      if(creditCardFormValid && addressFormValid){
  		if($('#CheckoutPaymentForm #save_CC').is(":checked")){
  			window.digitalDataEvents = window.digitalDataEvents || [ ];
  			digitalDataEvents.push( {uimsg:"Checkout Flow | Default Payment Method | Successfully Saved"} );

  		}
  	}
      if (creditCardFormValid) {
    	if(costcoStoreFeatures.MEMBERSHIP_CHECKOUT_AUTO_RENEW_OPTION_ENABLED !== 'undefined'
				&& costcoStoreFeatures.MEMBERSHIP_CHECKOUT_AUTO_RENEW_OPTION_ENABLED 
					&& $("input[name='isQuickPurchase']") != undefined && $("input[name='isQuickPurchase']") .val() == 'true'){
    		$('#cc_membership_renew_error').removeClass('critical-notification');
			$('#cc_membership_renew_error').addClass('alert-notification');
	    }  
        if (addressCompleted) {
        	if(OrderSummary.membershipTncValidator.isValid()){
          creditcard.submit.creditCardForm();
        	}
        } else {
          if (addressFormValid) {
        	  if(OrderSummary.membershipTncValidator.isValid()){
            $('body').bind('costco.address.added', function(event, address) {
              $('input[name=place-order]').attr('disabled', true);
              creditcard.submit.creditCardForm();
            });
            addressForm.submit(addressType, COSTCO.OrderSummary.preventHtmlReload);
          }
        }
        }
      } else {
    	if ($('#quick-membership-checkout').length > 0) {
    		$('body, html').animate({
                scrollTop: $('#creditcard').offset().top - 100,
             }, 500);
    		if(costcoStoreFeatures.MEMBERSHIP_CHECKOUT_AUTO_RENEW_OPTION_ENABLED !== 'undefined'
					&& costcoStoreFeatures.MEMBERSHIP_CHECKOUT_AUTO_RENEW_OPTION_ENABLED 
							&& $("input[name='isQuickPurchase']") != undefined &&$("input[name='isQuickPurchase']") .val() == 'true'){
				$('#cc_membership_renew_error').removeClass('alert-notification');
				$('#cc_membership_renew_error').addClass('critical-notification');
			}
    	} else {
    		$('html, body').animate({
    	          scrollTop: 200,
    	     }, 300);
    	}        
      }

      console.log('END - submit for review - ADDRESS VALIDATION');
    },
    
    validateCompanyNameLength: function validateCompanyNameLength() {
		  let errorElement = document.getElementById("company_name_validator_err_msg");
		  if ($('#companyNameId').val().trim().length > 0) {
			  var enteredValue = $('#companyNameId').val();
			  $(errorElement).addClass("hide");
			  $('#companyNameId').removeClass("error");
			  $('#companyNameSmall').removeClass("hide");
			  enteredValue = COSTCO.util.scrubSpecialCharsFromCompanyName(enteredValue);
			  sessionStorage.setItem("companyNamePickup",enteredValue);
			  $('#companyNameId').val(enteredValue);
		  }else{
			  $('#companyNameId').empty();
  			  $(errorElement).removeClass("hide");
  			  $('#companyNameId').addClass("error");
		  }
    },
    
    updateCompanyName: function validateCompanyNameLength() {
		  let errorElement = document.getElementById("company_name_validator_err_msg");
		  var updatedValue = $('#companyNameId').val();
		  if (updatedValue.trim().length > 0) {
			  updatedValue = COSTCO.util.scrubSpecialCharsFromCompanyName(updatedValue);
			  console.log("newStr: " + updatedValue);
			  $(errorElement).addClass("hide");
			  sessionStorage.setItem("companyNamePickup",updatedValue);
			  $('#companyNameId').val(updatedValue);
			  $('#companyNameId').removeClass("error");
			  $('#companyNameSmall').removeClass("hide");
			  $('#companyNameId').addClass("hide");
			  $('#company_name_display').removeClass("hide");
			  $('#companyNameSmall').addClass("hide");
			  $('#company_name_display').text(updatedValue);
			  $('#company_name_change_id').removeClass("hide");
		  }else{
			  $('#companyNameId').empty();
			  $(errorElement).removeClass("hide");
			  $('#companyNameId').addClass("error");
		  }
     },
    
	 enableCompanyNameInput: function enableCompanyNameInput(){
		  $('#companyNameSmall').removeClass("hide");
	  	  $('#companyNameId').removeClass("hide");
	  	  $('#company_name_display').addClass("hide");
	  	  $('#company_name_change_id').addClass("hide");
	  	  $('input[id=companyNameId]').focus();
    	  $('input[id=companyNameId]').select();
	 },
	 
    checkPaymentRadioSelection: function() {
      let selectionValid = true;
      let paymentMethodRadioVisible = (($('#credit-card-block').length > 0 && !$('#credit-card-block').hasClass('hide')) || 
    		  							(COSTCO.Checkout.displayAllPayments() && $('#credit-card-review-block').length > 0 && !$('#credit-card-review-block').hasClass('hide')) ||
      									($('#wallet-block').length > 0 && !$('#wallet-block').hasClass('hide')) || 
      									($('#applepay-block').length > 0 && !$('#applepay-block').hasClass('hide')) ||
      									($('#check-del-block').length > 0 && !$('#check-del-block').hasClass('hide'))) && !$('#payment-method-radio-buttons').hasClass('hide')
      if (!OrderSummary.isPaymentMethodRadioSelected() && paymentMethodRadioVisible) {
        creditcard.showErrorBox();
        wallet.showErrorBox();
        wallet.showErrorMessage(messages.ERROR_SELECT_PAYMENT_METHOD);
        selectionValid = false;
        
      } else if (wallet.walletCheckout == 'false') {
        if (wallet.isMasterpassOptionSelected()) {
          wallet.showErrorBox();
          wallet.showErrorMessage(messages.ERROR_SELECT_MASTERPASS);
          selectionValid = false;
        } else if (wallet.isVisacheckoutOptionSelected()) {
          wallet.showErrorBox();
          wallet.showErrorMessage(messages.ERROR_SELECT_VISA_CHECKOUT);
          selectionValid = false;
        } else if (wallet.isClickPayOptionSelected()) {
        	wallet.showErrorBox();
            wallet.showErrorMessage(messages.ERROR_SELECT_CLICKPAY);
            selectionValid = false;
        }
      }
      //if we are on Quick Renew Post lockdown page, scroll to error as it's not visible to the user
      if (selectionValid == false && ($('#membership-card-info-post-lockdown').length > 0 || $('#quick-membership-checkout').length > 0)) {
    	  $('body, html').animate({
              scrollTop: $('#creditcard').offset().top - 100,
            }, 500);
      }
      
      return selectionValid;
    },
    validateMembershipNumberBD: function() {
        return $('#membership-apply-form').validate({
          focusInvalid: false,
          rules: {
            'add-membership-number': {
              required: true,
              digits: true,
              minlength: 12,
              maxlength: 16,
            },
          },
          messages: {
            'add-membership-number': {
              required: messages.ERR_BD_REQUIRE_MEMBERSHIP,
              digits: messages.ERR_INVALID_MEMBERSHIP_NO_BD,
              minlength: messages.ERR_INVALID_MEMBERSHIP_NO_BD,
              maxlength: messages.ERR_INVALID_MEMBERSHIP_NO_BD,
            },
          },
          errorPlacement: function($error, $element) {
            let errorContainer = $('#membership-number-error');
            errorContainer.empty();
            errorContainer.append($error);
          },
        }).form();
      },
    /**
     * Validation for the membership number input
     * has to be numbers only and between 12 and 16 digits
     *
     * Membership is required if order has warehouse pickup item
     * it also have a special message
     *
     * errorPlacement is defined to ensure this validation
     * error message and the command error message are tied
     * together [so both are not shown in a weird way]
     *
     * @return {boolean} boolean value for valid input
     */
    validateMembershipNumber: function() {
      return $('#membership-apply-form').validate({
        focusInvalid: false,
        rules: {
          'add-membership-number': {
            required: orderStatic.orderRequireMembership || memberOnlyFeatureEnabled,
            digits: true,
            minlength: 12,
            maxlength: 16,
          },
        },
        messages: {
          'add-membership-number': {
            required: (orderStatic.orderRequireMembership) ? messages.ERR_WAREHOUSE_PICKUP_REQUIRE_MEMBERSHIP : messages.ERR_BD_REQUIRE_MEMBERSHIP,
            digits: messages.ERR_INVALID_MEMBERSHIP_NO,
            minlength: messages.ERR_INVALID_MEMBERSHIP_NO,
            maxlength: messages.ERR_INVALID_MEMBERSHIP_NO,
          },
        },
        errorPlacement: function($error, $element) {
          let errorContainer = $('#membership-number-error');
          errorContainer.empty();
          errorContainer.append($error);
        },
      }).form();
    },
    /**
     * validation for the promo code input
     *
     * @return {boolean} boolean value for valid input
     */
    validatePromoCode: function() {    	
       $('#promo-code-form').validate({
    	   errorElement: 'span',
    	   rules: {
          'enter-promo-code': 'required',
        },
        messages: {
          'enter-promo-code': messages.ERR_INVALID_PROMO_CODE,
        },
        invalidHandler: function(form, validator) {
        	
          var errors = validator.numberOfInvalids();
      	
          if (errors) {                    
              var firstInvalidElement = $(validator.errorList[0].element);              
              firstInvalidElement.focus();
          }
        },
        highlight: function(element, errorClass) {
        	 $(element).addClass(errorClass);        	
        },
    	unhighlight: COSTCO.util != undefined ? COSTCO.util.unhighlightWithErrorLabel : () => {},
        errorPlacement: function errorPlacement(error,element){				
			error.insertAfter(element);				
        },
      }).form();
      return  $("#promo-code-form").valid();
          
       
    },
    validatePromoAdjustments: function(){
        let isValid = true;
        $('.promo-adjustment').each(function() {
            let promoAdj = $(this).text();
            if (parseInt(promoAdj.replace(/[^\d]/g, '')) == 0) {
                isValid = false;
                if ($('#promo-code-success').contents().length > 0) {
                    $('#promo-code-success').empty().hide();
                }
                $('#promo-code-error').html('<p>' + messages.ERR_PROMOTION_CODE_NOT_APPLIED + '</p>');
                COSTCO.util.announceSRErrorMessage(messages.ERR_PROMOTION_CODE_NOT_APPLIED);
                return false;
            }
        });
        return isValid;
    },
    validateMinimumThreshold: function() {
    	let isValid = true;
        let minimumOrderAmount = parseFloat($('#minimumOrderAmount').val());
        let orderPreTax = parseFloat($.cookie('wcCartOrder'));
        if ($('#min-amount-notification').length) {
        	$('#min-amount-notification').remove();
        }
        if (minimumOrderAmount > orderPreTax) {
        	let difference = COSTCO.util.formatMoney((minimumOrderAmount - orderPreTax).toFixed(2));
            let errorText = messages.ERR_THRESHOLD_AMOUNT_MSG.replace('{0}', minimumOrderAmount).replace('{1}', difference);
            let $errorContainer = $('#notification-message');
            $errorContainer.append('<p id="min-amount-notification" class="critical-notification">' + errorText + '</p>');
            COSTCO.util.announceSRErrorMessage(errorText);
            $errorContainer.focus();
            $('body, html').animate({
              scrollTop: $errorContainer.offset().top - 30,
            }, 800);
            isValid = false;
        }
        return isValid;
    },
    uncheckPaymentRadio: function() {
    	$('input[name=payment-radio]').each(function(){
  		  $(this).prop('checked', false);
  	  });
    },
    /**
     * creditInputMsg : Display membership related message in payment page
     */
    creditInputMsg:function(){
    	if($('input[name=autoRenewEnableFlag]').val() === 'true' && $('input[name=isQuickPurchaseFlow]').val() === 'true'){
			$('#CheckoutPaymentForm').find('input[id=account]').on('click', function(event){
				let fieldValue = $('input[id=account]').val();
				  if( typeof(fieldValue) !== 'undefined' && fieldValue !== null && fieldValue !== ''){
					  $('.auto-renew-checkout').removeClass('hide');
				  }
			  });
			let creditcard = $('#CheckoutPaymentForm').find('input[id=account]').val();
			if( typeof(creditcard) === 'undefined' || creditcard === null || creditcard === ''){
				  $('.auto-renew-checkout').removeClass('hide');
			}		   
    	}
    },
    /**
     * Moves the Order Summary section to keep it in view when user scrolls.
     * The section only moves if the screen is Tablet Landscape or wider.
     */
    affix: function() {
      if (typeof(checkoutPage) === 'undefined' || checkoutPage == 'confirmation' || $('#order-summary-column').length === 0) {
        return;
      }
    
      let affixFunction = function() {
        let $orderSummary = $('#order-summary-column');
        let parentContainerBottom = $orderSummary.parent().offset().top + $orderSummary.parent().height();
        // the first checkout container element is initially top-aligned with order-summary so use it as reference
        let reference = $('.checkout-container:first').offset().top;

        let currentTranslateY = parseFloat($orderSummary.css('transform').split(',')[5]) || 0;
        let translateY = -$orderSummary[0].getBoundingClientRect().top + currentTranslateY;
        let maxDistance = parentContainerBottom - reference - $orderSummary.height();

        if (translateY > maxDistance) {
          translateY = maxDistance;
        } else if (translateY < 0) {
          translateY = 0;
        }

        $('#order-summary-column').css({
          '-webkit-transform': 'translateY(' + translateY + 'px)',
          '-moz-transform': 'translateY(' + translateY + 'px)',
          '-ms-transform': 'translateY(' + translateY + 'px)',
          '-o-transform': 'translateY(' + translateY + 'px)',
          'transform': 'translateY(' + translateY + 'px)',
        });
      };
      $(window).on('scroll wheel DOMMouseScroll mousewheel resize', function(evt) {
        // remove all transforms if screen is not at least tablet landscape
        if (COSTCO.util.isMaxScreen('TABLET-LANDSCAPE')) {
          $('#order-summary-column').css({
            '-webkit-transform': '',
            '-moz-transform': '',
            '-ms-transform': '',
            '-o-transform': '',
            'transform': '',
          });
        } else {
          affixFunction();
        }
      });
    },
    /**
     * Copies the attributes from CheckoutReviewForm into the CheckoutPaymentForm 
     * if the 'change' link has been clicked in the review page
     */
    prepareCheckoutPaymentFormForOrderSubmit: function(){
		if($("#CheckoutPaymentForm input[name=selDeliveryDate]").length){
			$("#CheckoutPaymentForm input[name=selDeliveryDate]").val($("#CheckoutReviewForm input[name=selDeliveryDate]").val());
		}
		if($("#CheckoutPaymentForm input[name=orderShipmodeId]").length){
			$("#CheckoutPaymentForm input[name=orderShipmodeId]").val($("#CheckoutReviewForm input[name=orderShipmodeId]").val());
		}
		$("#CheckoutPaymentForm input[name=deviceId]").val($("#CheckoutReviewForm input[name=deviceId]").val());
		$("#CheckoutPaymentForm input[name=setAsDefaultShippingAddress]").val($("#CheckoutReviewForm input[name=setAsDefaultShippingAddress]").val());
		$("#CheckoutPaymentForm input[name=doBillingPaymentCmd]").val('true');
		$("#CheckoutPaymentForm").attr("action", $("#CheckoutReviewForm").attr("action"));
    },
    
    hasPaymentSelectionChanged: function(){
    	var changedToCC = (creditcard.isSelected() && !creditcard.isUsed());
    	var changedToWallet = (wallet.isSelected() && !wallet.isUsed());
    	var changedToACH = (OrderSummary.isACHPaymentSelected() && !OrderSummary.isACHPaymentUsed());
    	var changedToAR = (OrderSummary.isARPaymentSelected() && !OrderSummary.isARPaymentUsed());
    	var changedToCOD = (OrderSummary.isCheckOnDeliverySelected() && !OrderSummary.isCheckOnDeliveryUsed());
    	var changedToApplePay = (applepay.isApplePaySelected() && !applepay.isApplePayUsed());
    	return (changedToCC || changedToWallet || changedToACH || changedToAR || changedToCOD || changedToApplePay);
    },
    /**
     * Function to display delivery surcharge for BD in ordersummary.
     * @param {number} orderTotal
     * @return {void}
     */
    displaySurchargeAmount: function(orderTotal) {
      let freeDeliveryOrderAmount = parseFloat($('#thresholdDeliveryAmount').val());
      let deliverySurcharge = parseFloat($('#deliverySurchargeAmount').val());
      let toolTipDeliverySurcharge = parseFloat($('#toolTipDeliverySurcharge').val()); 
      let currentOrderTotal = parseFloat($('#currentOrderTotal').val());
      let shipmodeId = parseFloat($('#shipmodeId').val());
      let $surchargeOrderTotalElement = costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE ? $('.surchargeOrderTotal') : $('#surchargeOrderTotal');
      
      if(typeof checkoutPage != 'undefined' && checkoutPage != 'confirmation'){
	      if (((checkoutPage == 'shipping') || (checkoutPage == 'review')) && $('input[name="deliveryMethod"]').length>0) {
	    	  shipmodeId = $('input[name="deliveryMethod"]:checked').val();
	    	  if(shipmodeId != undefined){
		    	  freeDeliveryOrderAmount = parseFloat($('#freeDeliveeryAmount_'+shipmodeId).val());
		          deliverySurcharge = parseFloat($('#surchargeAmount_'+shipmodeId).val());
	    	  }
	      }
	      if(shipmodeId == '10101' || shipmodeId == '10101_SP'){
	    	  $("#deldatepicker").prop('disabled', false);
	    	  $('#deldatepicker').addClass('enableDate');
	  		  $('.co-calendar').addClass('enableDate');
	  		  orderitems.delDatePicker();
	      }
	      else{
	    	  $("#deldatepicker").prop('disabled', true);
	  		  $('label[for="deldatepicker"]').css("display", "none");
	    	  $('#deldatepicker').removeClass('enableDate');
	  		  $('.co-calendar').removeClass('enableDate');
	  		  $("#deldatepicker").val('');
	      }
	      if (typeof orderTotal == "number" && freeDeliveryOrderAmount) {
	        if (orderTotal < freeDeliveryOrderAmount && orderTotal > 0) {
	          // Display delivery surcharge
	            $('.surcharge_amount').html('$' + deliverySurcharge.toFixed(2));
	            $('.free_delivery_fee').html('$' + freeDeliveryOrderAmount.toFixed(2));
	            if(shipmodeId == 10101){
	            	$(".surcharge-tooltip").attr("data-content",messages.HEADER_BANNER_TOOLTIP.replace('{0}', freeDeliveryOrderAmount).replace('{1}', toolTipDeliverySurcharge));
	            }
	            else{
	        		$(".surcharge-tooltip").attr("data-content",messages.HEADER_BANNER_TOOLTIP_GND);
	        	}
	        } else {
	          // zero delivery surcharge
	          $('.surcharge_amount').html('$0.00');
	          $(".surcharge-tooltip").attr("data-content",messages.DELIVERY_SURCHARGE_WAIVED);
	        }
	        if (COSTCO.util.isNdEnabled() && $surchargeOrderTotalElement.length > 0) {
	        	$surchargeOrderTotalElement.text('$' + (currentOrderTotal + deliverySurcharge).toFixed(2));
	         }
	      } else {
	        console.error('Invalid values for: orderTotal, freeDeliveryOrderAmount, and/or deliverySurcharge.');
	      }
      }
      if (checkoutPage == 'confirmation'){
    	  $('.quick-cart-summary').addClass('hide');
    	  $('.set-zip-code').removeClass('zipped');
      }
    },
    /**
     * Function to handle the shipmode logic in the delivery page
     */
    updateShipmodeDetails: function() {
	    if($('input[name="deliveryMethod"]').length>0){
	    	var shipmodeId = $('input[name="deliveryMethod"]:checked').val();

	    	if(shipmodeId == '10101' || shipmodeId == '10101_SP'){
	    		$('.delivery-option-bd').removeClass('hide');
	       	  	$('.delivery-option-ups').addClass('hide');
	       	  	$('.delivery-option-ltl').addClass('hide');
	    	}else{
	    		$('.delivery-option-bd').addClass('hide');
	      	  	if(shipmodeId == 10102){
	    	  		$('.delivery-option-ups').removeClass('hide');
	    	  		$('.delivery-option-ltl').addClass('hide');
		  		}
		  		else{
		  			$('.delivery-option-ltl').removeClass('hide');
		  			$('.delivery-option-ups').addClass('hide');
		  		}
	    	}
	    }
    },
    /**
     * updateSelectedShipDetails : Used in case of user choice and adrress change from review page.
     * 	Update the shipmode against the order by invoking CostcoOrderItemUpdateShipModeCmd
     *  	User Choice :- need to repaint the delivery method section and payment of the review page
     *  	Addresschange : the input param will be undefined and no repaint will be happen,Only trigger an ajax call to 
     *  					save the derived shipmode for the new address
     *  For rest of the checkout pages only the js function(displaySurchargeAmount() & updateShipmodeDetails())
     *  will be executed for the shipmode changes
     */
    updateSelectedShipDetails : function(orderTotal,input){
    	 var shipmodeId = 10101;
    	 if($('input[name="deliveryMethod"]').length>0){
    		 shipmodeId = $('input[name="deliveryMethod"]:checked').val();
    	 }
    	if(checkoutPage == 'review'){
    		 var error_container = $('.error.check').length > 0 ? '.error.check' : '#errquantity_';
    		 var orderId =  $('#ShopCartForm').find('[name=orderId]').val();
    		 let inputContainer = input;
    		 checkout_helper.ajax_update_state({
    	          error_container: error_container,
    	          page: typeof checkoutPage !== "undefined" ? checkoutPage : 'cart',
    	          url: '/CostcoOrderItemUpdateShipModeCmd',
    	          method: 'POST',
    	          data: [{
    	            name: "shipModeId",
    	            value: shipmodeId || ""
    	          }, {
    	            name: "orderId",
    	            value: orderId || ""
    	          }, {
    	        	name: "AjaxShipModeUpdateReview",
    	            value: true || ""
    		      }],
    	          always: function(){
    	        	  if(input != undefined){
	    	        	COSTCO.Checkout.ajax_update_default_always(inputContainer);
	    	        	COSTCO.OrderItems.init();
	    	        	COSTCO.OrderSummary.displaySurchargeAmount(orderTotal);
	    	    		COSTCO.OrderSummary.updateShipmodeDetails();
    	        	  }else{
    	        		  window.location.reload();
    	        	  }
    	          },
    	          inputContainer: inputContainer
    	        });
    		
    	}else{
    		 if(input != undefined){
	    		COSTCO.OrderSummary.displaySurchargeAmount(orderTotal);
	    		COSTCO.OrderSummary.updateShipmodeDetails();
    		 }else{
       		  window.location.reload(); 
       	  }
    	}
    },
    /**
     * updateShippmentDetails : Used for updating order shipmode by invoking CostcoOrderItemUpdateShipModeCmdImpl(BC)/CostcoOrderShipmodeUpdateCmdImpl(BD) from checkout page
     */
    updateShippmentDetails : function(orderTotal,input, shipModeId, deliveryIndicator){
    	
      $("#deldatepicker-div-" + deliveryIndicator).removeClass('hide');
      if (deliveryIndicator === 'store-Pick-Up') {
    	  $('#deldatepicker-div-local-delivery').addClass('hide');
    	  deliveryIndicator = "Store-Pick-Up";
      } else if (deliveryIndicator === 'local-delivery') {
    	  $('#deldatepicker-div-store-Pick-Up').addClass('hide');
    	  deliveryIndicator = "Local";
      } else if (deliveryIndicator === 'national-delivery') {
    	  $('#deldatepicker-div-local-delivery').addClass('hide');
    	  $('#deldatepicker-div-store-Pick-Up').addClass('hide');
    	  deliveryIndicator = "Nationwide";
      }
      
      let deliveryDate = '';
      let makeAjaxCall = false;
      
      if (deliveryIndicator === OrderSummary.deliveryIndicator) {
          
	      //COSTCO.OrderItems.delDatePicker();
	      
	      deliveryDate = $('input#deldatepicker').val();
	      let currentElement = $(event).length > 0 ? $(event.currentTarget) : null;
	      if ((currentElement !== null && (currentElement.val() === '10101' || currentElement.val() ==='10101_SP')) || 
	    	  (currentElement !== null && (currentElement.find('input#deldatepicker').length > 0 || currentElement.attr('id') === 'deldatepicker'))) {
	    	if(currentElement.is('label')) {
	    		$('input#delivery-option-' + shipModeId + '-' + deliveryIndicator).attr('checked', true);
	    	}
	
	        $('#deldatepicker').unbind('change').on('change', function(){
	            COSTCO.OrderSummary.updateShippmentDetails(orderTotal,input, shipModeId, deliveryIndicator);
	        });
	
	        COSTCO.OrderSummary.displaySurchargeAmount(orderTotal);
	        COSTCO.OrderSummary.updateShipmodeDetails();
	        $('#deldatepicker').focus();
	      } else if(currentElement !== null) {
	        makeAjaxCall = true
	      }
	      
      } else {
    	  OrderSummary.deliveryIndicator = deliveryIndicator;
    	  makeAjaxCall = true;
      }	        
      
      let error_container = $('.error.check').length > 0 ? '.error.check' : '#errquantity_';
      let orderId =  $('#single-page-checkout').find('[name=orderId]').val();

      let inputContainer = input;
      if (makeAjaxCall) {
    
    	checkout_helper.ajax_update_state({
        error_container: error_container,
        page: typeof checkoutPage !== "undefined" ? checkoutPage : 'cart',
        url: '/CostcoOrderItemUpdateShipModeCmd',
        method: 'POST',
        data: [{
          name: "shipModeId",
          value: shipModeId || ""
          }, {
          name: "orderId",
          value: orderId || ""
          }, {
          name: "deliveryDate",
          value: deliveryDate || ""
          }, {
          name: "userSelectionDeliveryMethod",
          value: deliveryIndicator || ""
          }
          ],
        done: function(data, textStatus, jqXHR, options) {
        	if(costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE) {
        		COSTCO.CreditCard.initComplete = false;
        	}
        	checkout_helper.ajax_update_default_done(data, textStatus, jqXHR, options);
        },
        always: function() {
          if (input != undefined) {
            COSTCO.Checkout.ajax_update_default_always(inputContainer);
            COSTCO.OrderItems.init();
            COSTCO.OrderSummary.displaySurchargeAmount(orderTotal);
            COSTCO.OrderSummary.updateShipmodeDetails();
            
            if(typeof COSTCO.CreditCard !== 'undefined'){
      		  COSTCO.CreditCard.initComplete = false;
      		  COSTCO.CreditCard.init();
      	  	}
            
            // Reinitialise the modal...
            COSTCO.deliverymethodinfomodal.init();

            if ((deliveryIndicator === 'Store-Pick-Up' || deliveryIndicator === 'Local') && deliveryDate == '') {

            	$('.checkout-delivery-date-bd').addClass('checkout-delivery-date');
            	$('.checkout-delivery-date-bd').removeClass('hide');
            	$('#choose-delivery-method').removeClass('hide');
            	$('#delivery-method').addClass('hide');
            	if(costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE) {
            		$('label[for="deldatepicker"]').css("display", "block");
            	}

            }
            
          } else {
            window.location.reload();
          }
        },
        inputContainer: inputContainer
      });
      }
    },
    /**
     * Function used to check if scheduled delivery date has been set
     * in case local delivery is the selected delivery option.
     */
    isDateSelectedForLocalDelivery: function() {
      let selectedElement = $(event.relatedTarget);
      if (selectedElement.find('input[name=deliveryMethod]') !== undefined && selectedElement.find('input[name=deliveryMethod]').val() !== '10102') {
        if (selectedElement.attr('id') !== 'deldatepicker-local' && selectedElement.attr('id') !== 'deldatepicker-store-Pick-Up') {
          COSTCO.OrderSummary.validateDate();
        }
      }
    },
    /**
     * Function to handle the change link in delivery method in delivery page.
     * If current delivery is local it sets eventHandler on date picker field
     */
    chooseDeliveryMethod: function(isLocalDelivery) {
    	$('.checkout-delivery-date-bd').addClass('checkout-delivery-date');
    	$('.checkout-delivery-date-bd').removeClass('hide');
    	$('#choose-delivery-method').removeClass('hide');
    	$('#delivery-method').addClass('hide');
    	if(costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE) {
    		$('label[for="deldatepicker"]').css("display", "block");
    	}
      if ($('input[name="deliveryMethod"]').length>0) {
        let shipmodeId = $('input[name="deliveryMethod"]:checked').val();
        if (shipmodeId != '10101' && shipmodeId != '10101_SP') {
	    		$("#deldatepicker").prop('disabled', true);
	    		$("#deldatepicker").val('');
        } else if (isLocalDelivery){
          let orderTotal = parseFloat($.cookie('wcCartOrder'));
          $('#deldatepicker').unbind('change').on('change', function(e){
        	  COSTCO.OrderSummary.updateShippmentDetails(orderTotal, $(this));
          });
          COSTCO.OrderItems.showDatePicker();
        }
      }
    },
    
    /**
     * Function to handle the change link in delivery method in delivery page
	 * in case when external carrier (ND) feature is off.
     */
    chooseDeliveryMethodNdOff: function() {
        $('#change-delopt-bd, #delivery-options-nd-off-display').addClass('hide');
        $('#delivery-options').removeClass('hide');
        if ($('#deldatepicker').val().length === 0) {
          let cookieDate = $.cookie('deliveryDateCookie');
          let date_str = COSTCO.OrderItems.getDisplayDateFormatForReview(cookieDate);
          $('#deldatepicker').val(date_str);
          $('label[for="deldatepicker"]').addClass('active');
        }
    },
    
    /**
     * Function to switch from edit to display mode of datepicker when external carrier
     * (ND) feature is off.
     */
    hideDeliveryMethodNdOff: function() {
      if(event != undefined && event.target != document && checkoutPage === 'review') {
        let cookieDate = $.cookie('deliveryDateCookie');
        let date_str = COSTCO.OrderItems.getDisplayDateFormatForReview(cookieDate);
        $('#ship-date-nd-off-display').html(date_str);
        $('#change-delopt-bd, #delivery-options-nd-off-display').removeClass('hide');
        $('#delivery-options').addClass('hide');
      }
    },

    /**
     * This function is used to submit form relative to the parameter passed which represent formName and to update sms phone for order
     * @param formName
     * @return {void}
     */
    submitFormByNameAndUpdateSmsPhone: function (formName) {
      $(formName).submit();
    },
    /**
     * Configure fail safe page to display member privileges and conditions
     * if user continues from checkout page without marking the checkbox
     * for membership purchase.
     */
    configureTncFailSafePage: function(){
    	$('#tnc-error').addClass('hidden');
    	$('#quick-membership-checkout').addClass('hide');    	
		$('#tncFailSafe-block').removeClass('hide');
		$('html, body').animate({scrollTop: 0},1);
		//Event handler for place order button
		$('input[name=place-order-fail-safe]').unbind('click').on('click', () => {$('input[name=place-order]').click()});
		//Event handler for cancel button
		$('#cancel-fail-safe').unbind('click').on('click', () => {
			$('#quick-membership-checkout').removeClass('hide');
			$('#tncFailSafe-block').addClass('hide');
			$('#tnc-failSafe-checkbox').prop('checked',false);
			$('html, body').animate({scrollTop: 0},1);
			$('#tAndCScrollBox').animate({scrollTop: 0},1);
			$('#tnc-failsafe-error').empty();
			$('#tnc-error').empty();
    		$('#tnc-checkDiv .checkout-container-body').removeClass('membership-tnc-checkbox-error-box');
    		$('#tnc-check-block').removeClass('membership-tnc-checkbox-error-box');
			OrderSummary.membershipTncValidator.checkoutForm().destroyValidator(OrderSummary.membershipTncValidator.checkoutForm().validate());
			OrderSummary.membershipTncValidator.validateScroll();
		});
    },
    /**
     * Validator object for Membership terms and conditions in membership
     * checkout flow.
     */
    membershipTncValidator: {
    	checkoutForm: () => $('#quick-membership-tnc'),
    	failSafeForm: () => $('#tnc-fail-safe'),
    	isValid: () => {
    		let self = OrderSummary.membershipTncValidator;
    		let valid = true;
    		if($('#tncFailSafe-block').length && $('#tncFailSafe-block').is(":visible")){
    			self.failSafeForm().destroyValidator(self.failSafeForm().validate());
    			self.failSafeForm().validate(self.failSafeSettings);
    			valid = self.failSafeForm().valid();
    		} else if($('#membership-terms-div').length && $('#membership-terms-div').is(":visible")){
    			self.checkoutForm().destroyValidator(self.checkoutForm().validate());
    			self.addTncValidationRules();
    			self.checkoutForm().validate(self.settings);
    			valid = self.checkoutForm().valid();
    		}
    		return valid;
    	},
    	validateScroll: () => {
    		let self = OrderSummary.membershipTncValidator;
    		$('#tAndCScrollBox').scroll(function(){
    			if ($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight) {
    	    		  OrderSummary.isQuickMembershipTncScrolled = true;
    	    		  $('#tnc-error').addClass('hidden');
    	    		  $('#membership-terms-div .checkout-container-body').removeClass('membership-tnc-checkbox-error-box');
    	    		  $('#membership-terms-div .checkout-container-body').removeClass('membership-tnc-checkbox-inactive');
    	    		  $('#membership-terms-div .checkout-container-body').addClass('membership-tnc-checkbox-active');
    	    		  $('#tnc-checkbox').focus();
    	    	  }
    	      });    		
    		self.checkoutForm().validate({
    			onclick: () => {
    				if(OrderSummary.isQuickMembershipTncScrolled){
        				$('#tnc-error').addClass('hidden');
        			}else{
        				$('#tnc-checkbox').prop('checked',false);
        				$('#tnc-error').empty();
        				$('#tnc-error').append(messages.ERR_MEMBERSHIP_TNC_NOT_SCROLLED);
        				$('#tnc-error').removeClass('hidden');
        				$('#tnc-checkbox').focus();
        				$('#membership-terms-div .checkout-container-body').addClass('membership-tnc-checkbox-error-box');
        			}
    			}
    		});
    	},
    	addTncValidationRules: () => {
    		$.validator.addMethod('isActiveChecked', function(value,element){
        		if(OrderSummary.isQuickMembershipTncScrolled){
        			if(!$('#tnc-checkbox').is(':checked')) {
        				return false;
        			} else if($("#tnc-check-block").hasClass("membership-tnc-checkbox-error-box")) {
        				$("#tnc-error").empty();
                        $("#tnc-checkDiv .checkout-container-body").removeClass("membership-tnc-checkbox-error-box");
                        $("#tnc-check-block").removeClass("membership-tnc-checkbox-error-box");
        			}
        		}
        		return true;
        	});
    		$.validator.addMethod('isIgnored', function(value,element){
    			if(!OrderSummary.isQuickMembershipTncScrolled && !$('#tnc-checkbox').is(':checked')){
    				return false;
    			}
    			return true;
    		});
    		$.validator.addMethod('isFailSafeIgnored', function(value,element){
    			if($('#tnc-failSafe-checkbox').is(':checked') &&
    					$('#tnc-checkDiv .checkout-container-body').hasClass('membership-tnc-checkbox-error-box')){
    				return false;
    			}
    			return true;
    		});
    	},
    	settings: {    		
    		rules: {
    			'tnc-checkbox': {isActiveChecked: true, isIgnored: true}
    		},
    		messages: {
    			'tnc-checkbox':{isActiveChecked: messages.ERR_MEMBERSHIP_TNC_NOT_CHECKED,
    				isIgnored: 'TNC_IGNORED'}
    		},
    		errorPlacement: (error, element) => {
    			if(error.html()=='TNC_IGNORED'){
    				OrderSummary.configureTncFailSafePage();
    			}else{
    				$('#tnc-error').empty();
        			$('#tnc-error').append(error.html());
        			$('#tnc-error').removeClass('hidden');
        			$('#membership-terms-div .checkout-container-body').addClass('membership-tnc-checkbox-error-box');
        			OrderSummary.membershipTncValidator.checkoutForm().validate().focusInvalid();
    			}    			
    		}
    	},
    	failSafeSettings: {
    		rules: {
    			'tnc-failSafe-checkbox': {required: true, isFailSafeIgnored: true}
    		},
    		messages: {
    			'tnc-failSafe-checkbox': {required: messages.ERR_MEMBERSHIP_TNC_NOT_CHECKED,
    				isFailSafeIgnored: 'TNC_IGNORED'}
    		},
    		errorPlacement: ($error, $element) => {
    			if($error.html() === 'TNC_IGNORED'){
    				$('#tnc-failsafe-error').empty();
            		$('#tnc-failsafe-error').addClass('hidden');
            		$('#tnc-checkDiv .checkout-container-body').removeClass('membership-tnc-checkbox-error-box');
    			} else {
    				$('#tnc-failsafe-error').empty();
            		$('#tnc-failsafe-error').append($error.html());
            		$('#tnc-failsafe-error').removeClass('hidden');
            		$('#tnc-failsafe-error').focus();
            		$('#tnc-checkDiv .checkout-container-body').addClass('membership-tnc-checkbox-error-box');
    			}
    		}
    	}
    	
    },
    
	executeMembershipRecaptcha: function() {
		COSTCO.DigitalWallet.executeReCaptcha($('#membershipRecaptcha').data('widgetid'));
	}
  };
  if (typeof window.COSTCO === 'undefined') {
    window.COSTCO = {};
  }
  window.COSTCO.OrderSummary = OrderSummary;
  return OrderSummary;
});



// WEBPACK FOOTER //
// ./js/checkout/ordersummary.js